/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SuccessChangePassAccountRouteImport } from './routes/success-change-pass-account'
import { Route as InboxRouteImport } from './routes/inbox'
import { Route as HelpSupportRouteImport } from './routes/help-support'
import { Route as DeleteAccountSuccessRouteImport } from './routes/delete-account-success'
import { Route as AccountVerifyEmailRouteImport } from './routes/account-verify-email'
import { Route as AccountChangePasswordRouteImport } from './routes/account-change-password'
import { Route as AccountRouteImport } from './routes/account'
import { Route as ManageBookingRouteRouteImport } from './routes/manage-booking/route'
import { Route as HomeRouteRouteImport } from './routes/home/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ManageBookingIndexRouteImport } from './routes/manage-booking/index'
import { Route as HomeIndexRouteImport } from './routes/home/index'
import { Route as DemoTanstackQueryRouteImport } from './routes/demo.tanstack-query'
import { Route as AuthVerifyEmailRouteImport } from './routes/auth/verify-email'
import { Route as AuthSuccessRegisterRouteImport } from './routes/auth/success-register'
import { Route as AuthSuccessChangePassRouteImport } from './routes/auth/success-change-pass'
import { Route as AuthResetPasswordRouteImport } from './routes/auth/reset-password'
import { Route as AuthRegisterRouteImport } from './routes/auth/register'
import { Route as AuthLogoutRouteImport } from './routes/auth/logout'
import { Route as AuthLoginRouteImport } from './routes/auth/login'
import { Route as AuthCheckYourInboxRouteImport } from './routes/auth/check-your-inbox'
import { Route as AuthChangePasswordRouteImport } from './routes/auth/change-password'
import { Route as MyBookingListRouteRouteImport } from './routes/my-booking/list/route'
import { Route as MyBookingIdRouteRouteImport } from './routes/my-booking/$id/route'
import { Route as ManageBookingIdRouteRouteImport } from './routes/manage-booking/$id/route'
import { Route as MakeBookingIdRouteRouteImport } from './routes/make-booking/$id/route'
import { Route as MyBookingIdIndexRouteImport } from './routes/my-booking/$id/index'
import { Route as ManageBookingIdIndexRouteImport } from './routes/manage-booking/$id/index'
import { Route as MakeBookingIdIndexRouteImport } from './routes/make-booking/$id/index'
import { Route as MyBookingIdPaymentRouteImport } from './routes/my-booking/$id/payment'
import { Route as MyBookingRefundIdRouteRouteImport } from './routes/my-booking/refund/$id/route'
import { Route as MyBookingListIdRouteRouteImport } from './routes/my-booking/list/$id/route'
import { Route as MyBookingIdViewRouteRouteImport } from './routes/my-booking/$id/view/route'
import { Route as MyBookingIdCancelRouteRouteImport } from './routes/my-booking/$id/cancel/route'
import { Route as MyBookingIdAmendRouteRouteImport } from './routes/my-booking/$id/amend/route'
import { Route as MakeBookingIdTripDetailsRouteRouteImport } from './routes/make-booking/$id/trip-details/route'
import { Route as MakeBookingIdPaymentRouteRouteImport } from './routes/make-booking/$id/payment/route'
import { Route as MakeBookingIdCheckoutRouteRouteImport } from './routes/make-booking/$id/checkout/route'
import { Route as MyBookingIdCancelIndexRouteImport } from './routes/my-booking/$id/cancel/index'
import { Route as MakeBookingIdPaymentIndexRouteImport } from './routes/make-booking/$id/payment/index'
import { Route as MyBookingListIdDeleteRouteImport } from './routes/my-booking/list/$id/delete'
import { Route as MyBookingIdViewPocRouteImport } from './routes/my-booking/$id/view/poc'
import { Route as MyBookingIdViewPaymentDetailRouteImport } from './routes/my-booking/$id/view/payment-detail'
import { Route as MyBookingIdViewCancelRouteImport } from './routes/my-booking/$id/view/cancel'
import { Route as MyBookingIdAmendConfirmRouteImport } from './routes/my-booking/$id/amend/confirm'
import { Route as MakeBookingIdTripDetailsSigninRouteImport } from './routes/make-booking/$id/trip-details/signin'
import { Route as MakeBookingIdTripDetailsAddBusRouteImport } from './routes/make-booking/$id/trip-details/add-bus'
import { Route as MakeBookingIdPaymentSuccessRouteImport } from './routes/make-booking/$id/payment/success'
import { Route as MakeBookingIdPaymentProcessRouteImport } from './routes/make-booking/$id/payment/process'
import { Route as MakeBookingIdPaymentInfoRouteImport } from './routes/make-booking/$id/payment/info'
import { Route as MakeBookingIdPaymentFailedRouteImport } from './routes/make-booking/$id/payment/failed'
import { Route as MakeBookingIdPaymentConfirmedRouteImport } from './routes/make-booking/$id/payment/confirmed'
import { Route as MakeBookingIdPaymentCancelledRouteImport } from './routes/make-booking/$id/payment/cancelled'
import { Route as MakeBookingIdCheckoutPocRouteImport } from './routes/make-booking/$id/checkout/poc'
import { Route as MakeBookingIdCheckoutContactRouteImport } from './routes/make-booking/$id/checkout/contact'
import { Route as MakeBookingIdCheckoutBillingRouteImport } from './routes/make-booking/$id/checkout/billing'
import { Route as MyBookingRefundIdTransportationIdRouteRouteImport } from './routes/my-booking/refund/$id/$transportationId/route'
import { Route as MyBookingIdViewTransportationIdRouteRouteImport } from './routes/my-booking/$id/view/$transportationId/route'
import { Route as MyBookingIdCancelConfirmRouteRouteImport } from './routes/my-booking/$id/cancel/confirm/route'
import { Route as MyBookingIdAmendViewRouteRouteImport } from './routes/my-booking/$id/amend/view/route'
import { Route as MakeBookingIdTripDetailsTransportationIdRouteRouteImport } from './routes/make-booking/$id/trip-details/$transportationId/route'
import { Route as MakeBookingIdCheckoutTransportationIdRouteRouteImport } from './routes/make-booking/$id/checkout/$transportationId/route'
import { Route as MakeBookingIdBusDetailsTransportationIdRouteRouteImport } from './routes/make-booking/$id/bus-details/$transportationId/route'
import { Route as MyBookingRefundIdTransportationIdDetailRouteImport } from './routes/my-booking/refund/$id/$transportationId/detail'
import { Route as MyBookingIdViewTransportationIdDetailRouteImport } from './routes/my-booking/$id/view/$transportationId/detail'
import { Route as MyBookingIdViewTransportationIdAmendRouteImport } from './routes/my-booking/$id/view/$transportationId/amend'
import { Route as MakeBookingIdTripDetailsTransportationIdDeleteRouteImport } from './routes/make-booking/$id/trip-details/$transportationId/delete'
import { Route as MakeBookingIdCheckoutTransportationIdDetailRouteImport } from './routes/make-booking/$id/checkout/$transportationId/detail'
import { Route as MakeBookingIdBusDetailsTransportationIdChangeBusRouteImport } from './routes/make-booking/$id/bus-details/$transportationId/change-bus'
import { Route as MyBookingIdAmendViewTransportationIdRouteRouteImport } from './routes/my-booking/$id/amend/view/$transportationId/route'
import { Route as MakeBookingIdBusDetailsTransportationIdTripTypeRouteRouteImport } from './routes/make-booking/$id/bus-details/$transportationId/trip-type/route'
import { Route as MakeBookingIdBusDetailsTransportationIdTimeRouteRouteImport } from './routes/make-booking/$id/bus-details/$transportationId/time/route'
import { Route as MakeBookingIdBusDetailsTransportationIdRoutesRouteRouteImport } from './routes/make-booking/$id/bus-details/$transportationId/routes/route'
import { Route as MakeBookingIdBusDetailsTransportationIdDateRouteRouteImport } from './routes/make-booking/$id/bus-details/$transportationId/date/route'
import { Route as MakeBookingIdBusDetailsTransportationIdAddOnsRouteRouteImport } from './routes/make-booking/$id/bus-details/$transportationId/add-ons/route'
import { Route as MakeBookingIdBusDetailsTransportationIdTripTypeIndexRouteImport } from './routes/make-booking/$id/bus-details/$transportationId/trip-type/index'
import { Route as MakeBookingIdBusDetailsTransportationIdTimeIndexRouteImport } from './routes/make-booking/$id/bus-details/$transportationId/time/index'
import { Route as MakeBookingIdBusDetailsTransportationIdRoutesIndexRouteImport } from './routes/make-booking/$id/bus-details/$transportationId/routes/index'
import { Route as MakeBookingIdBusDetailsTransportationIdDateIndexRouteImport } from './routes/make-booking/$id/bus-details/$transportationId/date/index'
import { Route as MakeBookingIdBusDetailsTransportationIdAddOnsIndexRouteImport } from './routes/make-booking/$id/bus-details/$transportationId/add-ons/index'
import { Route as MyBookingIdCancelConfirmTransportationIdDetailRouteImport } from './routes/my-booking/$id/cancel/confirm/$transportationId/detail'
import { Route as MyBookingIdAmendViewTransportationIdDetailRouteImport } from './routes/my-booking/$id/amend/view/$transportationId/detail'

const SuccessChangePassAccountRoute =
  SuccessChangePassAccountRouteImport.update({
    id: '/success-change-pass-account',
    path: '/success-change-pass-account',
    getParentRoute: () => rootRouteImport,
  } as any)
const InboxRoute = InboxRouteImport.update({
  id: '/inbox',
  path: '/inbox',
  getParentRoute: () => rootRouteImport,
} as any)
const HelpSupportRoute = HelpSupportRouteImport.update({
  id: '/help-support',
  path: '/help-support',
  getParentRoute: () => rootRouteImport,
} as any)
const DeleteAccountSuccessRoute = DeleteAccountSuccessRouteImport.update({
  id: '/delete-account-success',
  path: '/delete-account-success',
  getParentRoute: () => rootRouteImport,
} as any)
const AccountVerifyEmailRoute = AccountVerifyEmailRouteImport.update({
  id: '/account-verify-email',
  path: '/account-verify-email',
  getParentRoute: () => rootRouteImport,
} as any)
const AccountChangePasswordRoute = AccountChangePasswordRouteImport.update({
  id: '/account-change-password',
  path: '/account-change-password',
  getParentRoute: () => rootRouteImport,
} as any)
const AccountRoute = AccountRouteImport.update({
  id: '/account',
  path: '/account',
  getParentRoute: () => rootRouteImport,
} as any)
const ManageBookingRouteRoute = ManageBookingRouteRouteImport.update({
  id: '/manage-booking',
  path: '/manage-booking',
  getParentRoute: () => rootRouteImport,
} as any)
const HomeRouteRoute = HomeRouteRouteImport.update({
  id: '/home',
  path: '/home',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const ManageBookingIndexRoute = ManageBookingIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ManageBookingRouteRoute,
} as any)
const HomeIndexRoute = HomeIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => HomeRouteRoute,
} as any)
const DemoTanstackQueryRoute = DemoTanstackQueryRouteImport.update({
  id: '/demo/tanstack-query',
  path: '/demo/tanstack-query',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthVerifyEmailRoute = AuthVerifyEmailRouteImport.update({
  id: '/auth/verify-email',
  path: '/auth/verify-email',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthSuccessRegisterRoute = AuthSuccessRegisterRouteImport.update({
  id: '/auth/success-register',
  path: '/auth/success-register',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthSuccessChangePassRoute = AuthSuccessChangePassRouteImport.update({
  id: '/auth/success-change-pass',
  path: '/auth/success-change-pass',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthResetPasswordRoute = AuthResetPasswordRouteImport.update({
  id: '/auth/reset-password',
  path: '/auth/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRegisterRoute = AuthRegisterRouteImport.update({
  id: '/auth/register',
  path: '/auth/register',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthLogoutRoute = AuthLogoutRouteImport.update({
  id: '/auth/logout',
  path: '/auth/logout',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthLoginRoute = AuthLoginRouteImport.update({
  id: '/auth/login',
  path: '/auth/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthCheckYourInboxRoute = AuthCheckYourInboxRouteImport.update({
  id: '/auth/check-your-inbox',
  path: '/auth/check-your-inbox',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthChangePasswordRoute = AuthChangePasswordRouteImport.update({
  id: '/auth/change-password',
  path: '/auth/change-password',
  getParentRoute: () => rootRouteImport,
} as any)
const MyBookingListRouteRoute = MyBookingListRouteRouteImport.update({
  id: '/my-booking/list',
  path: '/my-booking/list',
  getParentRoute: () => rootRouteImport,
} as any)
const MyBookingIdRouteRoute = MyBookingIdRouteRouteImport.update({
  id: '/my-booking/$id',
  path: '/my-booking/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const ManageBookingIdRouteRoute = ManageBookingIdRouteRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => ManageBookingRouteRoute,
} as any)
const MakeBookingIdRouteRoute = MakeBookingIdRouteRouteImport.update({
  id: '/make-booking/$id',
  path: '/make-booking/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const MyBookingIdIndexRoute = MyBookingIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => MyBookingIdRouteRoute,
} as any)
const ManageBookingIdIndexRoute = ManageBookingIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ManageBookingIdRouteRoute,
} as any)
const MakeBookingIdIndexRoute = MakeBookingIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => MakeBookingIdRouteRoute,
} as any)
const MyBookingIdPaymentRoute = MyBookingIdPaymentRouteImport.update({
  id: '/payment',
  path: '/payment',
  getParentRoute: () => MyBookingIdRouteRoute,
} as any)
const MyBookingRefundIdRouteRoute = MyBookingRefundIdRouteRouteImport.update({
  id: '/my-booking/refund/$id',
  path: '/my-booking/refund/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const MyBookingListIdRouteRoute = MyBookingListIdRouteRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => MyBookingListRouteRoute,
} as any)
const MyBookingIdViewRouteRoute = MyBookingIdViewRouteRouteImport.update({
  id: '/view',
  path: '/view',
  getParentRoute: () => MyBookingIdRouteRoute,
} as any)
const MyBookingIdCancelRouteRoute = MyBookingIdCancelRouteRouteImport.update({
  id: '/cancel',
  path: '/cancel',
  getParentRoute: () => MyBookingIdRouteRoute,
} as any)
const MyBookingIdAmendRouteRoute = MyBookingIdAmendRouteRouteImport.update({
  id: '/amend',
  path: '/amend',
  getParentRoute: () => MyBookingIdRouteRoute,
} as any)
const MakeBookingIdTripDetailsRouteRoute =
  MakeBookingIdTripDetailsRouteRouteImport.update({
    id: '/trip-details',
    path: '/trip-details',
    getParentRoute: () => MakeBookingIdRouteRoute,
  } as any)
const MakeBookingIdPaymentRouteRoute =
  MakeBookingIdPaymentRouteRouteImport.update({
    id: '/payment',
    path: '/payment',
    getParentRoute: () => MakeBookingIdRouteRoute,
  } as any)
const MakeBookingIdCheckoutRouteRoute =
  MakeBookingIdCheckoutRouteRouteImport.update({
    id: '/checkout',
    path: '/checkout',
    getParentRoute: () => MakeBookingIdRouteRoute,
  } as any)
const MyBookingIdCancelIndexRoute = MyBookingIdCancelIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => MyBookingIdCancelRouteRoute,
} as any)
const MakeBookingIdPaymentIndexRoute =
  MakeBookingIdPaymentIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => MakeBookingIdPaymentRouteRoute,
  } as any)
const MyBookingListIdDeleteRoute = MyBookingListIdDeleteRouteImport.update({
  id: '/delete',
  path: '/delete',
  getParentRoute: () => MyBookingListIdRouteRoute,
} as any)
const MyBookingIdViewPocRoute = MyBookingIdViewPocRouteImport.update({
  id: '/poc',
  path: '/poc',
  getParentRoute: () => MyBookingIdViewRouteRoute,
} as any)
const MyBookingIdViewPaymentDetailRoute =
  MyBookingIdViewPaymentDetailRouteImport.update({
    id: '/payment-detail',
    path: '/payment-detail',
    getParentRoute: () => MyBookingIdViewRouteRoute,
  } as any)
const MyBookingIdViewCancelRoute = MyBookingIdViewCancelRouteImport.update({
  id: '/cancel',
  path: '/cancel',
  getParentRoute: () => MyBookingIdViewRouteRoute,
} as any)
const MyBookingIdAmendConfirmRoute = MyBookingIdAmendConfirmRouteImport.update({
  id: '/confirm',
  path: '/confirm',
  getParentRoute: () => MyBookingIdAmendRouteRoute,
} as any)
const MakeBookingIdTripDetailsSigninRoute =
  MakeBookingIdTripDetailsSigninRouteImport.update({
    id: '/signin',
    path: '/signin',
    getParentRoute: () => MakeBookingIdTripDetailsRouteRoute,
  } as any)
const MakeBookingIdTripDetailsAddBusRoute =
  MakeBookingIdTripDetailsAddBusRouteImport.update({
    id: '/add-bus',
    path: '/add-bus',
    getParentRoute: () => MakeBookingIdTripDetailsRouteRoute,
  } as any)
const MakeBookingIdPaymentSuccessRoute =
  MakeBookingIdPaymentSuccessRouteImport.update({
    id: '/success',
    path: '/success',
    getParentRoute: () => MakeBookingIdPaymentRouteRoute,
  } as any)
const MakeBookingIdPaymentProcessRoute =
  MakeBookingIdPaymentProcessRouteImport.update({
    id: '/process',
    path: '/process',
    getParentRoute: () => MakeBookingIdPaymentRouteRoute,
  } as any)
const MakeBookingIdPaymentInfoRoute =
  MakeBookingIdPaymentInfoRouteImport.update({
    id: '/info',
    path: '/info',
    getParentRoute: () => MakeBookingIdPaymentRouteRoute,
  } as any)
const MakeBookingIdPaymentFailedRoute =
  MakeBookingIdPaymentFailedRouteImport.update({
    id: '/failed',
    path: '/failed',
    getParentRoute: () => MakeBookingIdPaymentRouteRoute,
  } as any)
const MakeBookingIdPaymentConfirmedRoute =
  MakeBookingIdPaymentConfirmedRouteImport.update({
    id: '/confirmed',
    path: '/confirmed',
    getParentRoute: () => MakeBookingIdPaymentRouteRoute,
  } as any)
const MakeBookingIdPaymentCancelledRoute =
  MakeBookingIdPaymentCancelledRouteImport.update({
    id: '/cancelled',
    path: '/cancelled',
    getParentRoute: () => MakeBookingIdPaymentRouteRoute,
  } as any)
const MakeBookingIdCheckoutPocRoute =
  MakeBookingIdCheckoutPocRouteImport.update({
    id: '/poc',
    path: '/poc',
    getParentRoute: () => MakeBookingIdCheckoutRouteRoute,
  } as any)
const MakeBookingIdCheckoutContactRoute =
  MakeBookingIdCheckoutContactRouteImport.update({
    id: '/contact',
    path: '/contact',
    getParentRoute: () => MakeBookingIdCheckoutRouteRoute,
  } as any)
const MakeBookingIdCheckoutBillingRoute =
  MakeBookingIdCheckoutBillingRouteImport.update({
    id: '/billing',
    path: '/billing',
    getParentRoute: () => MakeBookingIdCheckoutRouteRoute,
  } as any)
const MyBookingRefundIdTransportationIdRouteRoute =
  MyBookingRefundIdTransportationIdRouteRouteImport.update({
    id: '/$transportationId',
    path: '/$transportationId',
    getParentRoute: () => MyBookingRefundIdRouteRoute,
  } as any)
const MyBookingIdViewTransportationIdRouteRoute =
  MyBookingIdViewTransportationIdRouteRouteImport.update({
    id: '/$transportationId',
    path: '/$transportationId',
    getParentRoute: () => MyBookingIdViewRouteRoute,
  } as any)
const MyBookingIdCancelConfirmRouteRoute =
  MyBookingIdCancelConfirmRouteRouteImport.update({
    id: '/confirm',
    path: '/confirm',
    getParentRoute: () => MyBookingIdCancelRouteRoute,
  } as any)
const MyBookingIdAmendViewRouteRoute =
  MyBookingIdAmendViewRouteRouteImport.update({
    id: '/view',
    path: '/view',
    getParentRoute: () => MyBookingIdAmendRouteRoute,
  } as any)
const MakeBookingIdTripDetailsTransportationIdRouteRoute =
  MakeBookingIdTripDetailsTransportationIdRouteRouteImport.update({
    id: '/$transportationId',
    path: '/$transportationId',
    getParentRoute: () => MakeBookingIdTripDetailsRouteRoute,
  } as any)
const MakeBookingIdCheckoutTransportationIdRouteRoute =
  MakeBookingIdCheckoutTransportationIdRouteRouteImport.update({
    id: '/$transportationId',
    path: '/$transportationId',
    getParentRoute: () => MakeBookingIdCheckoutRouteRoute,
  } as any)
const MakeBookingIdBusDetailsTransportationIdRouteRoute =
  MakeBookingIdBusDetailsTransportationIdRouteRouteImport.update({
    id: '/bus-details/$transportationId',
    path: '/bus-details/$transportationId',
    getParentRoute: () => MakeBookingIdRouteRoute,
  } as any)
const MyBookingRefundIdTransportationIdDetailRoute =
  MyBookingRefundIdTransportationIdDetailRouteImport.update({
    id: '/detail',
    path: '/detail',
    getParentRoute: () => MyBookingRefundIdTransportationIdRouteRoute,
  } as any)
const MyBookingIdViewTransportationIdDetailRoute =
  MyBookingIdViewTransportationIdDetailRouteImport.update({
    id: '/detail',
    path: '/detail',
    getParentRoute: () => MyBookingIdViewTransportationIdRouteRoute,
  } as any)
const MyBookingIdViewTransportationIdAmendRoute =
  MyBookingIdViewTransportationIdAmendRouteImport.update({
    id: '/amend',
    path: '/amend',
    getParentRoute: () => MyBookingIdViewTransportationIdRouteRoute,
  } as any)
const MakeBookingIdTripDetailsTransportationIdDeleteRoute =
  MakeBookingIdTripDetailsTransportationIdDeleteRouteImport.update({
    id: '/delete',
    path: '/delete',
    getParentRoute: () => MakeBookingIdTripDetailsTransportationIdRouteRoute,
  } as any)
const MakeBookingIdCheckoutTransportationIdDetailRoute =
  MakeBookingIdCheckoutTransportationIdDetailRouteImport.update({
    id: '/detail',
    path: '/detail',
    getParentRoute: () => MakeBookingIdCheckoutTransportationIdRouteRoute,
  } as any)
const MakeBookingIdBusDetailsTransportationIdChangeBusRoute =
  MakeBookingIdBusDetailsTransportationIdChangeBusRouteImport.update({
    id: '/change-bus',
    path: '/change-bus',
    getParentRoute: () => MakeBookingIdBusDetailsTransportationIdRouteRoute,
  } as any)
const MyBookingIdAmendViewTransportationIdRouteRoute =
  MyBookingIdAmendViewTransportationIdRouteRouteImport.update({
    id: '/$transportationId',
    path: '/$transportationId',
    getParentRoute: () => MyBookingIdAmendViewRouteRoute,
  } as any)
const MakeBookingIdBusDetailsTransportationIdTripTypeRouteRoute =
  MakeBookingIdBusDetailsTransportationIdTripTypeRouteRouteImport.update({
    id: '/trip-type',
    path: '/trip-type',
    getParentRoute: () => MakeBookingIdBusDetailsTransportationIdRouteRoute,
  } as any)
const MakeBookingIdBusDetailsTransportationIdTimeRouteRoute =
  MakeBookingIdBusDetailsTransportationIdTimeRouteRouteImport.update({
    id: '/time',
    path: '/time',
    getParentRoute: () => MakeBookingIdBusDetailsTransportationIdRouteRoute,
  } as any)
const MakeBookingIdBusDetailsTransportationIdRoutesRouteRoute =
  MakeBookingIdBusDetailsTransportationIdRoutesRouteRouteImport.update({
    id: '/routes',
    path: '/routes',
    getParentRoute: () => MakeBookingIdBusDetailsTransportationIdRouteRoute,
  } as any)
const MakeBookingIdBusDetailsTransportationIdDateRouteRoute =
  MakeBookingIdBusDetailsTransportationIdDateRouteRouteImport.update({
    id: '/date',
    path: '/date',
    getParentRoute: () => MakeBookingIdBusDetailsTransportationIdRouteRoute,
  } as any)
const MakeBookingIdBusDetailsTransportationIdAddOnsRouteRoute =
  MakeBookingIdBusDetailsTransportationIdAddOnsRouteRouteImport.update({
    id: '/add-ons',
    path: '/add-ons',
    getParentRoute: () => MakeBookingIdBusDetailsTransportationIdRouteRoute,
  } as any)
const MakeBookingIdBusDetailsTransportationIdTripTypeIndexRoute =
  MakeBookingIdBusDetailsTransportationIdTripTypeIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      MakeBookingIdBusDetailsTransportationIdTripTypeRouteRoute,
  } as any)
const MakeBookingIdBusDetailsTransportationIdTimeIndexRoute =
  MakeBookingIdBusDetailsTransportationIdTimeIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => MakeBookingIdBusDetailsTransportationIdTimeRouteRoute,
  } as any)
const MakeBookingIdBusDetailsTransportationIdRoutesIndexRoute =
  MakeBookingIdBusDetailsTransportationIdRoutesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      MakeBookingIdBusDetailsTransportationIdRoutesRouteRoute,
  } as any)
const MakeBookingIdBusDetailsTransportationIdDateIndexRoute =
  MakeBookingIdBusDetailsTransportationIdDateIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => MakeBookingIdBusDetailsTransportationIdDateRouteRoute,
  } as any)
const MakeBookingIdBusDetailsTransportationIdAddOnsIndexRoute =
  MakeBookingIdBusDetailsTransportationIdAddOnsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      MakeBookingIdBusDetailsTransportationIdAddOnsRouteRoute,
  } as any)
const MyBookingIdCancelConfirmTransportationIdDetailRoute =
  MyBookingIdCancelConfirmTransportationIdDetailRouteImport.update({
    id: '/$transportationId/detail',
    path: '/$transportationId/detail',
    getParentRoute: () => MyBookingIdCancelConfirmRouteRoute,
  } as any)
const MyBookingIdAmendViewTransportationIdDetailRoute =
  MyBookingIdAmendViewTransportationIdDetailRouteImport.update({
    id: '/detail',
    path: '/detail',
    getParentRoute: () => MyBookingIdAmendViewTransportationIdRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/home': typeof HomeRouteRouteWithChildren
  '/manage-booking': typeof ManageBookingRouteRouteWithChildren
  '/account': typeof AccountRoute
  '/account-change-password': typeof AccountChangePasswordRoute
  '/account-verify-email': typeof AccountVerifyEmailRoute
  '/delete-account-success': typeof DeleteAccountSuccessRoute
  '/help-support': typeof HelpSupportRoute
  '/inbox': typeof InboxRoute
  '/success-change-pass-account': typeof SuccessChangePassAccountRoute
  '/make-booking/$id': typeof MakeBookingIdRouteRouteWithChildren
  '/manage-booking/$id': typeof ManageBookingIdRouteRouteWithChildren
  '/my-booking/$id': typeof MyBookingIdRouteRouteWithChildren
  '/my-booking/list': typeof MyBookingListRouteRouteWithChildren
  '/auth/change-password': typeof AuthChangePasswordRoute
  '/auth/check-your-inbox': typeof AuthCheckYourInboxRoute
  '/auth/login': typeof AuthLoginRoute
  '/auth/logout': typeof AuthLogoutRoute
  '/auth/register': typeof AuthRegisterRoute
  '/auth/reset-password': typeof AuthResetPasswordRoute
  '/auth/success-change-pass': typeof AuthSuccessChangePassRoute
  '/auth/success-register': typeof AuthSuccessRegisterRoute
  '/auth/verify-email': typeof AuthVerifyEmailRoute
  '/demo/tanstack-query': typeof DemoTanstackQueryRoute
  '/home/': typeof HomeIndexRoute
  '/manage-booking/': typeof ManageBookingIndexRoute
  '/make-booking/$id/checkout': typeof MakeBookingIdCheckoutRouteRouteWithChildren
  '/make-booking/$id/payment': typeof MakeBookingIdPaymentRouteRouteWithChildren
  '/make-booking/$id/trip-details': typeof MakeBookingIdTripDetailsRouteRouteWithChildren
  '/my-booking/$id/amend': typeof MyBookingIdAmendRouteRouteWithChildren
  '/my-booking/$id/cancel': typeof MyBookingIdCancelRouteRouteWithChildren
  '/my-booking/$id/view': typeof MyBookingIdViewRouteRouteWithChildren
  '/my-booking/list/$id': typeof MyBookingListIdRouteRouteWithChildren
  '/my-booking/refund/$id': typeof MyBookingRefundIdRouteRouteWithChildren
  '/my-booking/$id/payment': typeof MyBookingIdPaymentRoute
  '/make-booking/$id/': typeof MakeBookingIdIndexRoute
  '/manage-booking/$id/': typeof ManageBookingIdIndexRoute
  '/my-booking/$id/': typeof MyBookingIdIndexRoute
  '/make-booking/$id/bus-details/$transportationId': typeof MakeBookingIdBusDetailsTransportationIdRouteRouteWithChildren
  '/make-booking/$id/checkout/$transportationId': typeof MakeBookingIdCheckoutTransportationIdRouteRouteWithChildren
  '/make-booking/$id/trip-details/$transportationId': typeof MakeBookingIdTripDetailsTransportationIdRouteRouteWithChildren
  '/my-booking/$id/amend/view': typeof MyBookingIdAmendViewRouteRouteWithChildren
  '/my-booking/$id/cancel/confirm': typeof MyBookingIdCancelConfirmRouteRouteWithChildren
  '/my-booking/$id/view/$transportationId': typeof MyBookingIdViewTransportationIdRouteRouteWithChildren
  '/my-booking/refund/$id/$transportationId': typeof MyBookingRefundIdTransportationIdRouteRouteWithChildren
  '/make-booking/$id/checkout/billing': typeof MakeBookingIdCheckoutBillingRoute
  '/make-booking/$id/checkout/contact': typeof MakeBookingIdCheckoutContactRoute
  '/make-booking/$id/checkout/poc': typeof MakeBookingIdCheckoutPocRoute
  '/make-booking/$id/payment/cancelled': typeof MakeBookingIdPaymentCancelledRoute
  '/make-booking/$id/payment/confirmed': typeof MakeBookingIdPaymentConfirmedRoute
  '/make-booking/$id/payment/failed': typeof MakeBookingIdPaymentFailedRoute
  '/make-booking/$id/payment/info': typeof MakeBookingIdPaymentInfoRoute
  '/make-booking/$id/payment/process': typeof MakeBookingIdPaymentProcessRoute
  '/make-booking/$id/payment/success': typeof MakeBookingIdPaymentSuccessRoute
  '/make-booking/$id/trip-details/add-bus': typeof MakeBookingIdTripDetailsAddBusRoute
  '/make-booking/$id/trip-details/signin': typeof MakeBookingIdTripDetailsSigninRoute
  '/my-booking/$id/amend/confirm': typeof MyBookingIdAmendConfirmRoute
  '/my-booking/$id/view/cancel': typeof MyBookingIdViewCancelRoute
  '/my-booking/$id/view/payment-detail': typeof MyBookingIdViewPaymentDetailRoute
  '/my-booking/$id/view/poc': typeof MyBookingIdViewPocRoute
  '/my-booking/list/$id/delete': typeof MyBookingListIdDeleteRoute
  '/make-booking/$id/payment/': typeof MakeBookingIdPaymentIndexRoute
  '/my-booking/$id/cancel/': typeof MyBookingIdCancelIndexRoute
  '/make-booking/$id/bus-details/$transportationId/add-ons': typeof MakeBookingIdBusDetailsTransportationIdAddOnsRouteRouteWithChildren
  '/make-booking/$id/bus-details/$transportationId/date': typeof MakeBookingIdBusDetailsTransportationIdDateRouteRouteWithChildren
  '/make-booking/$id/bus-details/$transportationId/routes': typeof MakeBookingIdBusDetailsTransportationIdRoutesRouteRouteWithChildren
  '/make-booking/$id/bus-details/$transportationId/time': typeof MakeBookingIdBusDetailsTransportationIdTimeRouteRouteWithChildren
  '/make-booking/$id/bus-details/$transportationId/trip-type': typeof MakeBookingIdBusDetailsTransportationIdTripTypeRouteRouteWithChildren
  '/my-booking/$id/amend/view/$transportationId': typeof MyBookingIdAmendViewTransportationIdRouteRouteWithChildren
  '/make-booking/$id/bus-details/$transportationId/change-bus': typeof MakeBookingIdBusDetailsTransportationIdChangeBusRoute
  '/make-booking/$id/checkout/$transportationId/detail': typeof MakeBookingIdCheckoutTransportationIdDetailRoute
  '/make-booking/$id/trip-details/$transportationId/delete': typeof MakeBookingIdTripDetailsTransportationIdDeleteRoute
  '/my-booking/$id/view/$transportationId/amend': typeof MyBookingIdViewTransportationIdAmendRoute
  '/my-booking/$id/view/$transportationId/detail': typeof MyBookingIdViewTransportationIdDetailRoute
  '/my-booking/refund/$id/$transportationId/detail': typeof MyBookingRefundIdTransportationIdDetailRoute
  '/my-booking/$id/amend/view/$transportationId/detail': typeof MyBookingIdAmendViewTransportationIdDetailRoute
  '/my-booking/$id/cancel/confirm/$transportationId/detail': typeof MyBookingIdCancelConfirmTransportationIdDetailRoute
  '/make-booking/$id/bus-details/$transportationId/add-ons/': typeof MakeBookingIdBusDetailsTransportationIdAddOnsIndexRoute
  '/make-booking/$id/bus-details/$transportationId/date/': typeof MakeBookingIdBusDetailsTransportationIdDateIndexRoute
  '/make-booking/$id/bus-details/$transportationId/routes/': typeof MakeBookingIdBusDetailsTransportationIdRoutesIndexRoute
  '/make-booking/$id/bus-details/$transportationId/time/': typeof MakeBookingIdBusDetailsTransportationIdTimeIndexRoute
  '/make-booking/$id/bus-details/$transportationId/trip-type/': typeof MakeBookingIdBusDetailsTransportationIdTripTypeIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/account': typeof AccountRoute
  '/account-change-password': typeof AccountChangePasswordRoute
  '/account-verify-email': typeof AccountVerifyEmailRoute
  '/delete-account-success': typeof DeleteAccountSuccessRoute
  '/help-support': typeof HelpSupportRoute
  '/inbox': typeof InboxRoute
  '/success-change-pass-account': typeof SuccessChangePassAccountRoute
  '/my-booking/list': typeof MyBookingListRouteRouteWithChildren
  '/auth/change-password': typeof AuthChangePasswordRoute
  '/auth/check-your-inbox': typeof AuthCheckYourInboxRoute
  '/auth/login': typeof AuthLoginRoute
  '/auth/logout': typeof AuthLogoutRoute
  '/auth/register': typeof AuthRegisterRoute
  '/auth/reset-password': typeof AuthResetPasswordRoute
  '/auth/success-change-pass': typeof AuthSuccessChangePassRoute
  '/auth/success-register': typeof AuthSuccessRegisterRoute
  '/auth/verify-email': typeof AuthVerifyEmailRoute
  '/demo/tanstack-query': typeof DemoTanstackQueryRoute
  '/home': typeof HomeIndexRoute
  '/manage-booking': typeof ManageBookingIndexRoute
  '/make-booking/$id/checkout': typeof MakeBookingIdCheckoutRouteRouteWithChildren
  '/make-booking/$id/trip-details': typeof MakeBookingIdTripDetailsRouteRouteWithChildren
  '/my-booking/$id/amend': typeof MyBookingIdAmendRouteRouteWithChildren
  '/my-booking/$id/view': typeof MyBookingIdViewRouteRouteWithChildren
  '/my-booking/list/$id': typeof MyBookingListIdRouteRouteWithChildren
  '/my-booking/refund/$id': typeof MyBookingRefundIdRouteRouteWithChildren
  '/my-booking/$id/payment': typeof MyBookingIdPaymentRoute
  '/make-booking/$id': typeof MakeBookingIdIndexRoute
  '/manage-booking/$id': typeof ManageBookingIdIndexRoute
  '/my-booking/$id': typeof MyBookingIdIndexRoute
  '/make-booking/$id/bus-details/$transportationId': typeof MakeBookingIdBusDetailsTransportationIdRouteRouteWithChildren
  '/make-booking/$id/checkout/$transportationId': typeof MakeBookingIdCheckoutTransportationIdRouteRouteWithChildren
  '/make-booking/$id/trip-details/$transportationId': typeof MakeBookingIdTripDetailsTransportationIdRouteRouteWithChildren
  '/my-booking/$id/amend/view': typeof MyBookingIdAmendViewRouteRouteWithChildren
  '/my-booking/$id/cancel/confirm': typeof MyBookingIdCancelConfirmRouteRouteWithChildren
  '/my-booking/$id/view/$transportationId': typeof MyBookingIdViewTransportationIdRouteRouteWithChildren
  '/my-booking/refund/$id/$transportationId': typeof MyBookingRefundIdTransportationIdRouteRouteWithChildren
  '/make-booking/$id/checkout/billing': typeof MakeBookingIdCheckoutBillingRoute
  '/make-booking/$id/checkout/contact': typeof MakeBookingIdCheckoutContactRoute
  '/make-booking/$id/checkout/poc': typeof MakeBookingIdCheckoutPocRoute
  '/make-booking/$id/payment/cancelled': typeof MakeBookingIdPaymentCancelledRoute
  '/make-booking/$id/payment/confirmed': typeof MakeBookingIdPaymentConfirmedRoute
  '/make-booking/$id/payment/failed': typeof MakeBookingIdPaymentFailedRoute
  '/make-booking/$id/payment/info': typeof MakeBookingIdPaymentInfoRoute
  '/make-booking/$id/payment/process': typeof MakeBookingIdPaymentProcessRoute
  '/make-booking/$id/payment/success': typeof MakeBookingIdPaymentSuccessRoute
  '/make-booking/$id/trip-details/add-bus': typeof MakeBookingIdTripDetailsAddBusRoute
  '/make-booking/$id/trip-details/signin': typeof MakeBookingIdTripDetailsSigninRoute
  '/my-booking/$id/amend/confirm': typeof MyBookingIdAmendConfirmRoute
  '/my-booking/$id/view/cancel': typeof MyBookingIdViewCancelRoute
  '/my-booking/$id/view/payment-detail': typeof MyBookingIdViewPaymentDetailRoute
  '/my-booking/$id/view/poc': typeof MyBookingIdViewPocRoute
  '/my-booking/list/$id/delete': typeof MyBookingListIdDeleteRoute
  '/make-booking/$id/payment': typeof MakeBookingIdPaymentIndexRoute
  '/my-booking/$id/cancel': typeof MyBookingIdCancelIndexRoute
  '/my-booking/$id/amend/view/$transportationId': typeof MyBookingIdAmendViewTransportationIdRouteRouteWithChildren
  '/make-booking/$id/bus-details/$transportationId/change-bus': typeof MakeBookingIdBusDetailsTransportationIdChangeBusRoute
  '/make-booking/$id/checkout/$transportationId/detail': typeof MakeBookingIdCheckoutTransportationIdDetailRoute
  '/make-booking/$id/trip-details/$transportationId/delete': typeof MakeBookingIdTripDetailsTransportationIdDeleteRoute
  '/my-booking/$id/view/$transportationId/amend': typeof MyBookingIdViewTransportationIdAmendRoute
  '/my-booking/$id/view/$transportationId/detail': typeof MyBookingIdViewTransportationIdDetailRoute
  '/my-booking/refund/$id/$transportationId/detail': typeof MyBookingRefundIdTransportationIdDetailRoute
  '/my-booking/$id/amend/view/$transportationId/detail': typeof MyBookingIdAmendViewTransportationIdDetailRoute
  '/my-booking/$id/cancel/confirm/$transportationId/detail': typeof MyBookingIdCancelConfirmTransportationIdDetailRoute
  '/make-booking/$id/bus-details/$transportationId/add-ons': typeof MakeBookingIdBusDetailsTransportationIdAddOnsIndexRoute
  '/make-booking/$id/bus-details/$transportationId/date': typeof MakeBookingIdBusDetailsTransportationIdDateIndexRoute
  '/make-booking/$id/bus-details/$transportationId/routes': typeof MakeBookingIdBusDetailsTransportationIdRoutesIndexRoute
  '/make-booking/$id/bus-details/$transportationId/time': typeof MakeBookingIdBusDetailsTransportationIdTimeIndexRoute
  '/make-booking/$id/bus-details/$transportationId/trip-type': typeof MakeBookingIdBusDetailsTransportationIdTripTypeIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/home': typeof HomeRouteRouteWithChildren
  '/manage-booking': typeof ManageBookingRouteRouteWithChildren
  '/account': typeof AccountRoute
  '/account-change-password': typeof AccountChangePasswordRoute
  '/account-verify-email': typeof AccountVerifyEmailRoute
  '/delete-account-success': typeof DeleteAccountSuccessRoute
  '/help-support': typeof HelpSupportRoute
  '/inbox': typeof InboxRoute
  '/success-change-pass-account': typeof SuccessChangePassAccountRoute
  '/make-booking/$id': typeof MakeBookingIdRouteRouteWithChildren
  '/manage-booking/$id': typeof ManageBookingIdRouteRouteWithChildren
  '/my-booking/$id': typeof MyBookingIdRouteRouteWithChildren
  '/my-booking/list': typeof MyBookingListRouteRouteWithChildren
  '/auth/change-password': typeof AuthChangePasswordRoute
  '/auth/check-your-inbox': typeof AuthCheckYourInboxRoute
  '/auth/login': typeof AuthLoginRoute
  '/auth/logout': typeof AuthLogoutRoute
  '/auth/register': typeof AuthRegisterRoute
  '/auth/reset-password': typeof AuthResetPasswordRoute
  '/auth/success-change-pass': typeof AuthSuccessChangePassRoute
  '/auth/success-register': typeof AuthSuccessRegisterRoute
  '/auth/verify-email': typeof AuthVerifyEmailRoute
  '/demo/tanstack-query': typeof DemoTanstackQueryRoute
  '/home/': typeof HomeIndexRoute
  '/manage-booking/': typeof ManageBookingIndexRoute
  '/make-booking/$id/checkout': typeof MakeBookingIdCheckoutRouteRouteWithChildren
  '/make-booking/$id/payment': typeof MakeBookingIdPaymentRouteRouteWithChildren
  '/make-booking/$id/trip-details': typeof MakeBookingIdTripDetailsRouteRouteWithChildren
  '/my-booking/$id/amend': typeof MyBookingIdAmendRouteRouteWithChildren
  '/my-booking/$id/cancel': typeof MyBookingIdCancelRouteRouteWithChildren
  '/my-booking/$id/view': typeof MyBookingIdViewRouteRouteWithChildren
  '/my-booking/list/$id': typeof MyBookingListIdRouteRouteWithChildren
  '/my-booking/refund/$id': typeof MyBookingRefundIdRouteRouteWithChildren
  '/my-booking/$id/payment': typeof MyBookingIdPaymentRoute
  '/make-booking/$id/': typeof MakeBookingIdIndexRoute
  '/manage-booking/$id/': typeof ManageBookingIdIndexRoute
  '/my-booking/$id/': typeof MyBookingIdIndexRoute
  '/make-booking/$id/bus-details/$transportationId': typeof MakeBookingIdBusDetailsTransportationIdRouteRouteWithChildren
  '/make-booking/$id/checkout/$transportationId': typeof MakeBookingIdCheckoutTransportationIdRouteRouteWithChildren
  '/make-booking/$id/trip-details/$transportationId': typeof MakeBookingIdTripDetailsTransportationIdRouteRouteWithChildren
  '/my-booking/$id/amend/view': typeof MyBookingIdAmendViewRouteRouteWithChildren
  '/my-booking/$id/cancel/confirm': typeof MyBookingIdCancelConfirmRouteRouteWithChildren
  '/my-booking/$id/view/$transportationId': typeof MyBookingIdViewTransportationIdRouteRouteWithChildren
  '/my-booking/refund/$id/$transportationId': typeof MyBookingRefundIdTransportationIdRouteRouteWithChildren
  '/make-booking/$id/checkout/billing': typeof MakeBookingIdCheckoutBillingRoute
  '/make-booking/$id/checkout/contact': typeof MakeBookingIdCheckoutContactRoute
  '/make-booking/$id/checkout/poc': typeof MakeBookingIdCheckoutPocRoute
  '/make-booking/$id/payment/cancelled': typeof MakeBookingIdPaymentCancelledRoute
  '/make-booking/$id/payment/confirmed': typeof MakeBookingIdPaymentConfirmedRoute
  '/make-booking/$id/payment/failed': typeof MakeBookingIdPaymentFailedRoute
  '/make-booking/$id/payment/info': typeof MakeBookingIdPaymentInfoRoute
  '/make-booking/$id/payment/process': typeof MakeBookingIdPaymentProcessRoute
  '/make-booking/$id/payment/success': typeof MakeBookingIdPaymentSuccessRoute
  '/make-booking/$id/trip-details/add-bus': typeof MakeBookingIdTripDetailsAddBusRoute
  '/make-booking/$id/trip-details/signin': typeof MakeBookingIdTripDetailsSigninRoute
  '/my-booking/$id/amend/confirm': typeof MyBookingIdAmendConfirmRoute
  '/my-booking/$id/view/cancel': typeof MyBookingIdViewCancelRoute
  '/my-booking/$id/view/payment-detail': typeof MyBookingIdViewPaymentDetailRoute
  '/my-booking/$id/view/poc': typeof MyBookingIdViewPocRoute
  '/my-booking/list/$id/delete': typeof MyBookingListIdDeleteRoute
  '/make-booking/$id/payment/': typeof MakeBookingIdPaymentIndexRoute
  '/my-booking/$id/cancel/': typeof MyBookingIdCancelIndexRoute
  '/make-booking/$id/bus-details/$transportationId/add-ons': typeof MakeBookingIdBusDetailsTransportationIdAddOnsRouteRouteWithChildren
  '/make-booking/$id/bus-details/$transportationId/date': typeof MakeBookingIdBusDetailsTransportationIdDateRouteRouteWithChildren
  '/make-booking/$id/bus-details/$transportationId/routes': typeof MakeBookingIdBusDetailsTransportationIdRoutesRouteRouteWithChildren
  '/make-booking/$id/bus-details/$transportationId/time': typeof MakeBookingIdBusDetailsTransportationIdTimeRouteRouteWithChildren
  '/make-booking/$id/bus-details/$transportationId/trip-type': typeof MakeBookingIdBusDetailsTransportationIdTripTypeRouteRouteWithChildren
  '/my-booking/$id/amend/view/$transportationId': typeof MyBookingIdAmendViewTransportationIdRouteRouteWithChildren
  '/make-booking/$id/bus-details/$transportationId/change-bus': typeof MakeBookingIdBusDetailsTransportationIdChangeBusRoute
  '/make-booking/$id/checkout/$transportationId/detail': typeof MakeBookingIdCheckoutTransportationIdDetailRoute
  '/make-booking/$id/trip-details/$transportationId/delete': typeof MakeBookingIdTripDetailsTransportationIdDeleteRoute
  '/my-booking/$id/view/$transportationId/amend': typeof MyBookingIdViewTransportationIdAmendRoute
  '/my-booking/$id/view/$transportationId/detail': typeof MyBookingIdViewTransportationIdDetailRoute
  '/my-booking/refund/$id/$transportationId/detail': typeof MyBookingRefundIdTransportationIdDetailRoute
  '/my-booking/$id/amend/view/$transportationId/detail': typeof MyBookingIdAmendViewTransportationIdDetailRoute
  '/my-booking/$id/cancel/confirm/$transportationId/detail': typeof MyBookingIdCancelConfirmTransportationIdDetailRoute
  '/make-booking/$id/bus-details/$transportationId/add-ons/': typeof MakeBookingIdBusDetailsTransportationIdAddOnsIndexRoute
  '/make-booking/$id/bus-details/$transportationId/date/': typeof MakeBookingIdBusDetailsTransportationIdDateIndexRoute
  '/make-booking/$id/bus-details/$transportationId/routes/': typeof MakeBookingIdBusDetailsTransportationIdRoutesIndexRoute
  '/make-booking/$id/bus-details/$transportationId/time/': typeof MakeBookingIdBusDetailsTransportationIdTimeIndexRoute
  '/make-booking/$id/bus-details/$transportationId/trip-type/': typeof MakeBookingIdBusDetailsTransportationIdTripTypeIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/home'
    | '/manage-booking'
    | '/account'
    | '/account-change-password'
    | '/account-verify-email'
    | '/delete-account-success'
    | '/help-support'
    | '/inbox'
    | '/success-change-pass-account'
    | '/make-booking/$id'
    | '/manage-booking/$id'
    | '/my-booking/$id'
    | '/my-booking/list'
    | '/auth/change-password'
    | '/auth/check-your-inbox'
    | '/auth/login'
    | '/auth/logout'
    | '/auth/register'
    | '/auth/reset-password'
    | '/auth/success-change-pass'
    | '/auth/success-register'
    | '/auth/verify-email'
    | '/demo/tanstack-query'
    | '/home/'
    | '/manage-booking/'
    | '/make-booking/$id/checkout'
    | '/make-booking/$id/payment'
    | '/make-booking/$id/trip-details'
    | '/my-booking/$id/amend'
    | '/my-booking/$id/cancel'
    | '/my-booking/$id/view'
    | '/my-booking/list/$id'
    | '/my-booking/refund/$id'
    | '/my-booking/$id/payment'
    | '/make-booking/$id/'
    | '/manage-booking/$id/'
    | '/my-booking/$id/'
    | '/make-booking/$id/bus-details/$transportationId'
    | '/make-booking/$id/checkout/$transportationId'
    | '/make-booking/$id/trip-details/$transportationId'
    | '/my-booking/$id/amend/view'
    | '/my-booking/$id/cancel/confirm'
    | '/my-booking/$id/view/$transportationId'
    | '/my-booking/refund/$id/$transportationId'
    | '/make-booking/$id/checkout/billing'
    | '/make-booking/$id/checkout/contact'
    | '/make-booking/$id/checkout/poc'
    | '/make-booking/$id/payment/cancelled'
    | '/make-booking/$id/payment/confirmed'
    | '/make-booking/$id/payment/failed'
    | '/make-booking/$id/payment/info'
    | '/make-booking/$id/payment/process'
    | '/make-booking/$id/payment/success'
    | '/make-booking/$id/trip-details/add-bus'
    | '/make-booking/$id/trip-details/signin'
    | '/my-booking/$id/amend/confirm'
    | '/my-booking/$id/view/cancel'
    | '/my-booking/$id/view/payment-detail'
    | '/my-booking/$id/view/poc'
    | '/my-booking/list/$id/delete'
    | '/make-booking/$id/payment/'
    | '/my-booking/$id/cancel/'
    | '/make-booking/$id/bus-details/$transportationId/add-ons'
    | '/make-booking/$id/bus-details/$transportationId/date'
    | '/make-booking/$id/bus-details/$transportationId/routes'
    | '/make-booking/$id/bus-details/$transportationId/time'
    | '/make-booking/$id/bus-details/$transportationId/trip-type'
    | '/my-booking/$id/amend/view/$transportationId'
    | '/make-booking/$id/bus-details/$transportationId/change-bus'
    | '/make-booking/$id/checkout/$transportationId/detail'
    | '/make-booking/$id/trip-details/$transportationId/delete'
    | '/my-booking/$id/view/$transportationId/amend'
    | '/my-booking/$id/view/$transportationId/detail'
    | '/my-booking/refund/$id/$transportationId/detail'
    | '/my-booking/$id/amend/view/$transportationId/detail'
    | '/my-booking/$id/cancel/confirm/$transportationId/detail'
    | '/make-booking/$id/bus-details/$transportationId/add-ons/'
    | '/make-booking/$id/bus-details/$transportationId/date/'
    | '/make-booking/$id/bus-details/$transportationId/routes/'
    | '/make-booking/$id/bus-details/$transportationId/time/'
    | '/make-booking/$id/bus-details/$transportationId/trip-type/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/account'
    | '/account-change-password'
    | '/account-verify-email'
    | '/delete-account-success'
    | '/help-support'
    | '/inbox'
    | '/success-change-pass-account'
    | '/my-booking/list'
    | '/auth/change-password'
    | '/auth/check-your-inbox'
    | '/auth/login'
    | '/auth/logout'
    | '/auth/register'
    | '/auth/reset-password'
    | '/auth/success-change-pass'
    | '/auth/success-register'
    | '/auth/verify-email'
    | '/demo/tanstack-query'
    | '/home'
    | '/manage-booking'
    | '/make-booking/$id/checkout'
    | '/make-booking/$id/trip-details'
    | '/my-booking/$id/amend'
    | '/my-booking/$id/view'
    | '/my-booking/list/$id'
    | '/my-booking/refund/$id'
    | '/my-booking/$id/payment'
    | '/make-booking/$id'
    | '/manage-booking/$id'
    | '/my-booking/$id'
    | '/make-booking/$id/bus-details/$transportationId'
    | '/make-booking/$id/checkout/$transportationId'
    | '/make-booking/$id/trip-details/$transportationId'
    | '/my-booking/$id/amend/view'
    | '/my-booking/$id/cancel/confirm'
    | '/my-booking/$id/view/$transportationId'
    | '/my-booking/refund/$id/$transportationId'
    | '/make-booking/$id/checkout/billing'
    | '/make-booking/$id/checkout/contact'
    | '/make-booking/$id/checkout/poc'
    | '/make-booking/$id/payment/cancelled'
    | '/make-booking/$id/payment/confirmed'
    | '/make-booking/$id/payment/failed'
    | '/make-booking/$id/payment/info'
    | '/make-booking/$id/payment/process'
    | '/make-booking/$id/payment/success'
    | '/make-booking/$id/trip-details/add-bus'
    | '/make-booking/$id/trip-details/signin'
    | '/my-booking/$id/amend/confirm'
    | '/my-booking/$id/view/cancel'
    | '/my-booking/$id/view/payment-detail'
    | '/my-booking/$id/view/poc'
    | '/my-booking/list/$id/delete'
    | '/make-booking/$id/payment'
    | '/my-booking/$id/cancel'
    | '/my-booking/$id/amend/view/$transportationId'
    | '/make-booking/$id/bus-details/$transportationId/change-bus'
    | '/make-booking/$id/checkout/$transportationId/detail'
    | '/make-booking/$id/trip-details/$transportationId/delete'
    | '/my-booking/$id/view/$transportationId/amend'
    | '/my-booking/$id/view/$transportationId/detail'
    | '/my-booking/refund/$id/$transportationId/detail'
    | '/my-booking/$id/amend/view/$transportationId/detail'
    | '/my-booking/$id/cancel/confirm/$transportationId/detail'
    | '/make-booking/$id/bus-details/$transportationId/add-ons'
    | '/make-booking/$id/bus-details/$transportationId/date'
    | '/make-booking/$id/bus-details/$transportationId/routes'
    | '/make-booking/$id/bus-details/$transportationId/time'
    | '/make-booking/$id/bus-details/$transportationId/trip-type'
  id:
    | '__root__'
    | '/'
    | '/home'
    | '/manage-booking'
    | '/account'
    | '/account-change-password'
    | '/account-verify-email'
    | '/delete-account-success'
    | '/help-support'
    | '/inbox'
    | '/success-change-pass-account'
    | '/make-booking/$id'
    | '/manage-booking/$id'
    | '/my-booking/$id'
    | '/my-booking/list'
    | '/auth/change-password'
    | '/auth/check-your-inbox'
    | '/auth/login'
    | '/auth/logout'
    | '/auth/register'
    | '/auth/reset-password'
    | '/auth/success-change-pass'
    | '/auth/success-register'
    | '/auth/verify-email'
    | '/demo/tanstack-query'
    | '/home/'
    | '/manage-booking/'
    | '/make-booking/$id/checkout'
    | '/make-booking/$id/payment'
    | '/make-booking/$id/trip-details'
    | '/my-booking/$id/amend'
    | '/my-booking/$id/cancel'
    | '/my-booking/$id/view'
    | '/my-booking/list/$id'
    | '/my-booking/refund/$id'
    | '/my-booking/$id/payment'
    | '/make-booking/$id/'
    | '/manage-booking/$id/'
    | '/my-booking/$id/'
    | '/make-booking/$id/bus-details/$transportationId'
    | '/make-booking/$id/checkout/$transportationId'
    | '/make-booking/$id/trip-details/$transportationId'
    | '/my-booking/$id/amend/view'
    | '/my-booking/$id/cancel/confirm'
    | '/my-booking/$id/view/$transportationId'
    | '/my-booking/refund/$id/$transportationId'
    | '/make-booking/$id/checkout/billing'
    | '/make-booking/$id/checkout/contact'
    | '/make-booking/$id/checkout/poc'
    | '/make-booking/$id/payment/cancelled'
    | '/make-booking/$id/payment/confirmed'
    | '/make-booking/$id/payment/failed'
    | '/make-booking/$id/payment/info'
    | '/make-booking/$id/payment/process'
    | '/make-booking/$id/payment/success'
    | '/make-booking/$id/trip-details/add-bus'
    | '/make-booking/$id/trip-details/signin'
    | '/my-booking/$id/amend/confirm'
    | '/my-booking/$id/view/cancel'
    | '/my-booking/$id/view/payment-detail'
    | '/my-booking/$id/view/poc'
    | '/my-booking/list/$id/delete'
    | '/make-booking/$id/payment/'
    | '/my-booking/$id/cancel/'
    | '/make-booking/$id/bus-details/$transportationId/add-ons'
    | '/make-booking/$id/bus-details/$transportationId/date'
    | '/make-booking/$id/bus-details/$transportationId/routes'
    | '/make-booking/$id/bus-details/$transportationId/time'
    | '/make-booking/$id/bus-details/$transportationId/trip-type'
    | '/my-booking/$id/amend/view/$transportationId'
    | '/make-booking/$id/bus-details/$transportationId/change-bus'
    | '/make-booking/$id/checkout/$transportationId/detail'
    | '/make-booking/$id/trip-details/$transportationId/delete'
    | '/my-booking/$id/view/$transportationId/amend'
    | '/my-booking/$id/view/$transportationId/detail'
    | '/my-booking/refund/$id/$transportationId/detail'
    | '/my-booking/$id/amend/view/$transportationId/detail'
    | '/my-booking/$id/cancel/confirm/$transportationId/detail'
    | '/make-booking/$id/bus-details/$transportationId/add-ons/'
    | '/make-booking/$id/bus-details/$transportationId/date/'
    | '/make-booking/$id/bus-details/$transportationId/routes/'
    | '/make-booking/$id/bus-details/$transportationId/time/'
    | '/make-booking/$id/bus-details/$transportationId/trip-type/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  HomeRouteRoute: typeof HomeRouteRouteWithChildren
  ManageBookingRouteRoute: typeof ManageBookingRouteRouteWithChildren
  AccountRoute: typeof AccountRoute
  AccountChangePasswordRoute: typeof AccountChangePasswordRoute
  AccountVerifyEmailRoute: typeof AccountVerifyEmailRoute
  DeleteAccountSuccessRoute: typeof DeleteAccountSuccessRoute
  HelpSupportRoute: typeof HelpSupportRoute
  InboxRoute: typeof InboxRoute
  SuccessChangePassAccountRoute: typeof SuccessChangePassAccountRoute
  MakeBookingIdRouteRoute: typeof MakeBookingIdRouteRouteWithChildren
  MyBookingIdRouteRoute: typeof MyBookingIdRouteRouteWithChildren
  MyBookingListRouteRoute: typeof MyBookingListRouteRouteWithChildren
  AuthChangePasswordRoute: typeof AuthChangePasswordRoute
  AuthCheckYourInboxRoute: typeof AuthCheckYourInboxRoute
  AuthLoginRoute: typeof AuthLoginRoute
  AuthLogoutRoute: typeof AuthLogoutRoute
  AuthRegisterRoute: typeof AuthRegisterRoute
  AuthResetPasswordRoute: typeof AuthResetPasswordRoute
  AuthSuccessChangePassRoute: typeof AuthSuccessChangePassRoute
  AuthSuccessRegisterRoute: typeof AuthSuccessRegisterRoute
  AuthVerifyEmailRoute: typeof AuthVerifyEmailRoute
  DemoTanstackQueryRoute: typeof DemoTanstackQueryRoute
  MyBookingRefundIdRouteRoute: typeof MyBookingRefundIdRouteRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/success-change-pass-account': {
      id: '/success-change-pass-account'
      path: '/success-change-pass-account'
      fullPath: '/success-change-pass-account'
      preLoaderRoute: typeof SuccessChangePassAccountRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/inbox': {
      id: '/inbox'
      path: '/inbox'
      fullPath: '/inbox'
      preLoaderRoute: typeof InboxRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/help-support': {
      id: '/help-support'
      path: '/help-support'
      fullPath: '/help-support'
      preLoaderRoute: typeof HelpSupportRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/delete-account-success': {
      id: '/delete-account-success'
      path: '/delete-account-success'
      fullPath: '/delete-account-success'
      preLoaderRoute: typeof DeleteAccountSuccessRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/account-verify-email': {
      id: '/account-verify-email'
      path: '/account-verify-email'
      fullPath: '/account-verify-email'
      preLoaderRoute: typeof AccountVerifyEmailRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/account-change-password': {
      id: '/account-change-password'
      path: '/account-change-password'
      fullPath: '/account-change-password'
      preLoaderRoute: typeof AccountChangePasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/account': {
      id: '/account'
      path: '/account'
      fullPath: '/account'
      preLoaderRoute: typeof AccountRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/manage-booking': {
      id: '/manage-booking'
      path: '/manage-booking'
      fullPath: '/manage-booking'
      preLoaderRoute: typeof ManageBookingRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/home': {
      id: '/home'
      path: '/home'
      fullPath: '/home'
      preLoaderRoute: typeof HomeRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/manage-booking/': {
      id: '/manage-booking/'
      path: '/'
      fullPath: '/manage-booking/'
      preLoaderRoute: typeof ManageBookingIndexRouteImport
      parentRoute: typeof ManageBookingRouteRoute
    }
    '/home/': {
      id: '/home/'
      path: '/'
      fullPath: '/home/'
      preLoaderRoute: typeof HomeIndexRouteImport
      parentRoute: typeof HomeRouteRoute
    }
    '/demo/tanstack-query': {
      id: '/demo/tanstack-query'
      path: '/demo/tanstack-query'
      fullPath: '/demo/tanstack-query'
      preLoaderRoute: typeof DemoTanstackQueryRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/verify-email': {
      id: '/auth/verify-email'
      path: '/auth/verify-email'
      fullPath: '/auth/verify-email'
      preLoaderRoute: typeof AuthVerifyEmailRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/success-register': {
      id: '/auth/success-register'
      path: '/auth/success-register'
      fullPath: '/auth/success-register'
      preLoaderRoute: typeof AuthSuccessRegisterRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/success-change-pass': {
      id: '/auth/success-change-pass'
      path: '/auth/success-change-pass'
      fullPath: '/auth/success-change-pass'
      preLoaderRoute: typeof AuthSuccessChangePassRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/reset-password': {
      id: '/auth/reset-password'
      path: '/auth/reset-password'
      fullPath: '/auth/reset-password'
      preLoaderRoute: typeof AuthResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/register': {
      id: '/auth/register'
      path: '/auth/register'
      fullPath: '/auth/register'
      preLoaderRoute: typeof AuthRegisterRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/logout': {
      id: '/auth/logout'
      path: '/auth/logout'
      fullPath: '/auth/logout'
      preLoaderRoute: typeof AuthLogoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/login': {
      id: '/auth/login'
      path: '/auth/login'
      fullPath: '/auth/login'
      preLoaderRoute: typeof AuthLoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/check-your-inbox': {
      id: '/auth/check-your-inbox'
      path: '/auth/check-your-inbox'
      fullPath: '/auth/check-your-inbox'
      preLoaderRoute: typeof AuthCheckYourInboxRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/change-password': {
      id: '/auth/change-password'
      path: '/auth/change-password'
      fullPath: '/auth/change-password'
      preLoaderRoute: typeof AuthChangePasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/my-booking/list': {
      id: '/my-booking/list'
      path: '/my-booking/list'
      fullPath: '/my-booking/list'
      preLoaderRoute: typeof MyBookingListRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/my-booking/$id': {
      id: '/my-booking/$id'
      path: '/my-booking/$id'
      fullPath: '/my-booking/$id'
      preLoaderRoute: typeof MyBookingIdRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/manage-booking/$id': {
      id: '/manage-booking/$id'
      path: '/$id'
      fullPath: '/manage-booking/$id'
      preLoaderRoute: typeof ManageBookingIdRouteRouteImport
      parentRoute: typeof ManageBookingRouteRoute
    }
    '/make-booking/$id': {
      id: '/make-booking/$id'
      path: '/make-booking/$id'
      fullPath: '/make-booking/$id'
      preLoaderRoute: typeof MakeBookingIdRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/my-booking/$id/': {
      id: '/my-booking/$id/'
      path: '/'
      fullPath: '/my-booking/$id/'
      preLoaderRoute: typeof MyBookingIdIndexRouteImport
      parentRoute: typeof MyBookingIdRouteRoute
    }
    '/manage-booking/$id/': {
      id: '/manage-booking/$id/'
      path: '/'
      fullPath: '/manage-booking/$id/'
      preLoaderRoute: typeof ManageBookingIdIndexRouteImport
      parentRoute: typeof ManageBookingIdRouteRoute
    }
    '/make-booking/$id/': {
      id: '/make-booking/$id/'
      path: '/'
      fullPath: '/make-booking/$id/'
      preLoaderRoute: typeof MakeBookingIdIndexRouteImport
      parentRoute: typeof MakeBookingIdRouteRoute
    }
    '/my-booking/$id/payment': {
      id: '/my-booking/$id/payment'
      path: '/payment'
      fullPath: '/my-booking/$id/payment'
      preLoaderRoute: typeof MyBookingIdPaymentRouteImport
      parentRoute: typeof MyBookingIdRouteRoute
    }
    '/my-booking/refund/$id': {
      id: '/my-booking/refund/$id'
      path: '/my-booking/refund/$id'
      fullPath: '/my-booking/refund/$id'
      preLoaderRoute: typeof MyBookingRefundIdRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/my-booking/list/$id': {
      id: '/my-booking/list/$id'
      path: '/$id'
      fullPath: '/my-booking/list/$id'
      preLoaderRoute: typeof MyBookingListIdRouteRouteImport
      parentRoute: typeof MyBookingListRouteRoute
    }
    '/my-booking/$id/view': {
      id: '/my-booking/$id/view'
      path: '/view'
      fullPath: '/my-booking/$id/view'
      preLoaderRoute: typeof MyBookingIdViewRouteRouteImport
      parentRoute: typeof MyBookingIdRouteRoute
    }
    '/my-booking/$id/cancel': {
      id: '/my-booking/$id/cancel'
      path: '/cancel'
      fullPath: '/my-booking/$id/cancel'
      preLoaderRoute: typeof MyBookingIdCancelRouteRouteImport
      parentRoute: typeof MyBookingIdRouteRoute
    }
    '/my-booking/$id/amend': {
      id: '/my-booking/$id/amend'
      path: '/amend'
      fullPath: '/my-booking/$id/amend'
      preLoaderRoute: typeof MyBookingIdAmendRouteRouteImport
      parentRoute: typeof MyBookingIdRouteRoute
    }
    '/make-booking/$id/trip-details': {
      id: '/make-booking/$id/trip-details'
      path: '/trip-details'
      fullPath: '/make-booking/$id/trip-details'
      preLoaderRoute: typeof MakeBookingIdTripDetailsRouteRouteImport
      parentRoute: typeof MakeBookingIdRouteRoute
    }
    '/make-booking/$id/payment': {
      id: '/make-booking/$id/payment'
      path: '/payment'
      fullPath: '/make-booking/$id/payment'
      preLoaderRoute: typeof MakeBookingIdPaymentRouteRouteImport
      parentRoute: typeof MakeBookingIdRouteRoute
    }
    '/make-booking/$id/checkout': {
      id: '/make-booking/$id/checkout'
      path: '/checkout'
      fullPath: '/make-booking/$id/checkout'
      preLoaderRoute: typeof MakeBookingIdCheckoutRouteRouteImport
      parentRoute: typeof MakeBookingIdRouteRoute
    }
    '/my-booking/$id/cancel/': {
      id: '/my-booking/$id/cancel/'
      path: '/'
      fullPath: '/my-booking/$id/cancel/'
      preLoaderRoute: typeof MyBookingIdCancelIndexRouteImport
      parentRoute: typeof MyBookingIdCancelRouteRoute
    }
    '/make-booking/$id/payment/': {
      id: '/make-booking/$id/payment/'
      path: '/'
      fullPath: '/make-booking/$id/payment/'
      preLoaderRoute: typeof MakeBookingIdPaymentIndexRouteImport
      parentRoute: typeof MakeBookingIdPaymentRouteRoute
    }
    '/my-booking/list/$id/delete': {
      id: '/my-booking/list/$id/delete'
      path: '/delete'
      fullPath: '/my-booking/list/$id/delete'
      preLoaderRoute: typeof MyBookingListIdDeleteRouteImport
      parentRoute: typeof MyBookingListIdRouteRoute
    }
    '/my-booking/$id/view/poc': {
      id: '/my-booking/$id/view/poc'
      path: '/poc'
      fullPath: '/my-booking/$id/view/poc'
      preLoaderRoute: typeof MyBookingIdViewPocRouteImport
      parentRoute: typeof MyBookingIdViewRouteRoute
    }
    '/my-booking/$id/view/payment-detail': {
      id: '/my-booking/$id/view/payment-detail'
      path: '/payment-detail'
      fullPath: '/my-booking/$id/view/payment-detail'
      preLoaderRoute: typeof MyBookingIdViewPaymentDetailRouteImport
      parentRoute: typeof MyBookingIdViewRouteRoute
    }
    '/my-booking/$id/view/cancel': {
      id: '/my-booking/$id/view/cancel'
      path: '/cancel'
      fullPath: '/my-booking/$id/view/cancel'
      preLoaderRoute: typeof MyBookingIdViewCancelRouteImport
      parentRoute: typeof MyBookingIdViewRouteRoute
    }
    '/my-booking/$id/amend/confirm': {
      id: '/my-booking/$id/amend/confirm'
      path: '/confirm'
      fullPath: '/my-booking/$id/amend/confirm'
      preLoaderRoute: typeof MyBookingIdAmendConfirmRouteImport
      parentRoute: typeof MyBookingIdAmendRouteRoute
    }
    '/make-booking/$id/trip-details/signin': {
      id: '/make-booking/$id/trip-details/signin'
      path: '/signin'
      fullPath: '/make-booking/$id/trip-details/signin'
      preLoaderRoute: typeof MakeBookingIdTripDetailsSigninRouteImport
      parentRoute: typeof MakeBookingIdTripDetailsRouteRoute
    }
    '/make-booking/$id/trip-details/add-bus': {
      id: '/make-booking/$id/trip-details/add-bus'
      path: '/add-bus'
      fullPath: '/make-booking/$id/trip-details/add-bus'
      preLoaderRoute: typeof MakeBookingIdTripDetailsAddBusRouteImport
      parentRoute: typeof MakeBookingIdTripDetailsRouteRoute
    }
    '/make-booking/$id/payment/success': {
      id: '/make-booking/$id/payment/success'
      path: '/success'
      fullPath: '/make-booking/$id/payment/success'
      preLoaderRoute: typeof MakeBookingIdPaymentSuccessRouteImport
      parentRoute: typeof MakeBookingIdPaymentRouteRoute
    }
    '/make-booking/$id/payment/process': {
      id: '/make-booking/$id/payment/process'
      path: '/process'
      fullPath: '/make-booking/$id/payment/process'
      preLoaderRoute: typeof MakeBookingIdPaymentProcessRouteImport
      parentRoute: typeof MakeBookingIdPaymentRouteRoute
    }
    '/make-booking/$id/payment/info': {
      id: '/make-booking/$id/payment/info'
      path: '/info'
      fullPath: '/make-booking/$id/payment/info'
      preLoaderRoute: typeof MakeBookingIdPaymentInfoRouteImport
      parentRoute: typeof MakeBookingIdPaymentRouteRoute
    }
    '/make-booking/$id/payment/failed': {
      id: '/make-booking/$id/payment/failed'
      path: '/failed'
      fullPath: '/make-booking/$id/payment/failed'
      preLoaderRoute: typeof MakeBookingIdPaymentFailedRouteImport
      parentRoute: typeof MakeBookingIdPaymentRouteRoute
    }
    '/make-booking/$id/payment/confirmed': {
      id: '/make-booking/$id/payment/confirmed'
      path: '/confirmed'
      fullPath: '/make-booking/$id/payment/confirmed'
      preLoaderRoute: typeof MakeBookingIdPaymentConfirmedRouteImport
      parentRoute: typeof MakeBookingIdPaymentRouteRoute
    }
    '/make-booking/$id/payment/cancelled': {
      id: '/make-booking/$id/payment/cancelled'
      path: '/cancelled'
      fullPath: '/make-booking/$id/payment/cancelled'
      preLoaderRoute: typeof MakeBookingIdPaymentCancelledRouteImport
      parentRoute: typeof MakeBookingIdPaymentRouteRoute
    }
    '/make-booking/$id/checkout/poc': {
      id: '/make-booking/$id/checkout/poc'
      path: '/poc'
      fullPath: '/make-booking/$id/checkout/poc'
      preLoaderRoute: typeof MakeBookingIdCheckoutPocRouteImport
      parentRoute: typeof MakeBookingIdCheckoutRouteRoute
    }
    '/make-booking/$id/checkout/contact': {
      id: '/make-booking/$id/checkout/contact'
      path: '/contact'
      fullPath: '/make-booking/$id/checkout/contact'
      preLoaderRoute: typeof MakeBookingIdCheckoutContactRouteImport
      parentRoute: typeof MakeBookingIdCheckoutRouteRoute
    }
    '/make-booking/$id/checkout/billing': {
      id: '/make-booking/$id/checkout/billing'
      path: '/billing'
      fullPath: '/make-booking/$id/checkout/billing'
      preLoaderRoute: typeof MakeBookingIdCheckoutBillingRouteImport
      parentRoute: typeof MakeBookingIdCheckoutRouteRoute
    }
    '/my-booking/refund/$id/$transportationId': {
      id: '/my-booking/refund/$id/$transportationId'
      path: '/$transportationId'
      fullPath: '/my-booking/refund/$id/$transportationId'
      preLoaderRoute: typeof MyBookingRefundIdTransportationIdRouteRouteImport
      parentRoute: typeof MyBookingRefundIdRouteRoute
    }
    '/my-booking/$id/view/$transportationId': {
      id: '/my-booking/$id/view/$transportationId'
      path: '/$transportationId'
      fullPath: '/my-booking/$id/view/$transportationId'
      preLoaderRoute: typeof MyBookingIdViewTransportationIdRouteRouteImport
      parentRoute: typeof MyBookingIdViewRouteRoute
    }
    '/my-booking/$id/cancel/confirm': {
      id: '/my-booking/$id/cancel/confirm'
      path: '/confirm'
      fullPath: '/my-booking/$id/cancel/confirm'
      preLoaderRoute: typeof MyBookingIdCancelConfirmRouteRouteImport
      parentRoute: typeof MyBookingIdCancelRouteRoute
    }
    '/my-booking/$id/amend/view': {
      id: '/my-booking/$id/amend/view'
      path: '/view'
      fullPath: '/my-booking/$id/amend/view'
      preLoaderRoute: typeof MyBookingIdAmendViewRouteRouteImport
      parentRoute: typeof MyBookingIdAmendRouteRoute
    }
    '/make-booking/$id/trip-details/$transportationId': {
      id: '/make-booking/$id/trip-details/$transportationId'
      path: '/$transportationId'
      fullPath: '/make-booking/$id/trip-details/$transportationId'
      preLoaderRoute: typeof MakeBookingIdTripDetailsTransportationIdRouteRouteImport
      parentRoute: typeof MakeBookingIdTripDetailsRouteRoute
    }
    '/make-booking/$id/checkout/$transportationId': {
      id: '/make-booking/$id/checkout/$transportationId'
      path: '/$transportationId'
      fullPath: '/make-booking/$id/checkout/$transportationId'
      preLoaderRoute: typeof MakeBookingIdCheckoutTransportationIdRouteRouteImport
      parentRoute: typeof MakeBookingIdCheckoutRouteRoute
    }
    '/make-booking/$id/bus-details/$transportationId': {
      id: '/make-booking/$id/bus-details/$transportationId'
      path: '/bus-details/$transportationId'
      fullPath: '/make-booking/$id/bus-details/$transportationId'
      preLoaderRoute: typeof MakeBookingIdBusDetailsTransportationIdRouteRouteImport
      parentRoute: typeof MakeBookingIdRouteRoute
    }
    '/my-booking/refund/$id/$transportationId/detail': {
      id: '/my-booking/refund/$id/$transportationId/detail'
      path: '/detail'
      fullPath: '/my-booking/refund/$id/$transportationId/detail'
      preLoaderRoute: typeof MyBookingRefundIdTransportationIdDetailRouteImport
      parentRoute: typeof MyBookingRefundIdTransportationIdRouteRoute
    }
    '/my-booking/$id/view/$transportationId/detail': {
      id: '/my-booking/$id/view/$transportationId/detail'
      path: '/detail'
      fullPath: '/my-booking/$id/view/$transportationId/detail'
      preLoaderRoute: typeof MyBookingIdViewTransportationIdDetailRouteImport
      parentRoute: typeof MyBookingIdViewTransportationIdRouteRoute
    }
    '/my-booking/$id/view/$transportationId/amend': {
      id: '/my-booking/$id/view/$transportationId/amend'
      path: '/amend'
      fullPath: '/my-booking/$id/view/$transportationId/amend'
      preLoaderRoute: typeof MyBookingIdViewTransportationIdAmendRouteImport
      parentRoute: typeof MyBookingIdViewTransportationIdRouteRoute
    }
    '/make-booking/$id/trip-details/$transportationId/delete': {
      id: '/make-booking/$id/trip-details/$transportationId/delete'
      path: '/delete'
      fullPath: '/make-booking/$id/trip-details/$transportationId/delete'
      preLoaderRoute: typeof MakeBookingIdTripDetailsTransportationIdDeleteRouteImport
      parentRoute: typeof MakeBookingIdTripDetailsTransportationIdRouteRoute
    }
    '/make-booking/$id/checkout/$transportationId/detail': {
      id: '/make-booking/$id/checkout/$transportationId/detail'
      path: '/detail'
      fullPath: '/make-booking/$id/checkout/$transportationId/detail'
      preLoaderRoute: typeof MakeBookingIdCheckoutTransportationIdDetailRouteImport
      parentRoute: typeof MakeBookingIdCheckoutTransportationIdRouteRoute
    }
    '/make-booking/$id/bus-details/$transportationId/change-bus': {
      id: '/make-booking/$id/bus-details/$transportationId/change-bus'
      path: '/change-bus'
      fullPath: '/make-booking/$id/bus-details/$transportationId/change-bus'
      preLoaderRoute: typeof MakeBookingIdBusDetailsTransportationIdChangeBusRouteImport
      parentRoute: typeof MakeBookingIdBusDetailsTransportationIdRouteRoute
    }
    '/my-booking/$id/amend/view/$transportationId': {
      id: '/my-booking/$id/amend/view/$transportationId'
      path: '/$transportationId'
      fullPath: '/my-booking/$id/amend/view/$transportationId'
      preLoaderRoute: typeof MyBookingIdAmendViewTransportationIdRouteRouteImport
      parentRoute: typeof MyBookingIdAmendViewRouteRoute
    }
    '/make-booking/$id/bus-details/$transportationId/trip-type': {
      id: '/make-booking/$id/bus-details/$transportationId/trip-type'
      path: '/trip-type'
      fullPath: '/make-booking/$id/bus-details/$transportationId/trip-type'
      preLoaderRoute: typeof MakeBookingIdBusDetailsTransportationIdTripTypeRouteRouteImport
      parentRoute: typeof MakeBookingIdBusDetailsTransportationIdRouteRoute
    }
    '/make-booking/$id/bus-details/$transportationId/time': {
      id: '/make-booking/$id/bus-details/$transportationId/time'
      path: '/time'
      fullPath: '/make-booking/$id/bus-details/$transportationId/time'
      preLoaderRoute: typeof MakeBookingIdBusDetailsTransportationIdTimeRouteRouteImport
      parentRoute: typeof MakeBookingIdBusDetailsTransportationIdRouteRoute
    }
    '/make-booking/$id/bus-details/$transportationId/routes': {
      id: '/make-booking/$id/bus-details/$transportationId/routes'
      path: '/routes'
      fullPath: '/make-booking/$id/bus-details/$transportationId/routes'
      preLoaderRoute: typeof MakeBookingIdBusDetailsTransportationIdRoutesRouteRouteImport
      parentRoute: typeof MakeBookingIdBusDetailsTransportationIdRouteRoute
    }
    '/make-booking/$id/bus-details/$transportationId/date': {
      id: '/make-booking/$id/bus-details/$transportationId/date'
      path: '/date'
      fullPath: '/make-booking/$id/bus-details/$transportationId/date'
      preLoaderRoute: typeof MakeBookingIdBusDetailsTransportationIdDateRouteRouteImport
      parentRoute: typeof MakeBookingIdBusDetailsTransportationIdRouteRoute
    }
    '/make-booking/$id/bus-details/$transportationId/add-ons': {
      id: '/make-booking/$id/bus-details/$transportationId/add-ons'
      path: '/add-ons'
      fullPath: '/make-booking/$id/bus-details/$transportationId/add-ons'
      preLoaderRoute: typeof MakeBookingIdBusDetailsTransportationIdAddOnsRouteRouteImport
      parentRoute: typeof MakeBookingIdBusDetailsTransportationIdRouteRoute
    }
    '/make-booking/$id/bus-details/$transportationId/trip-type/': {
      id: '/make-booking/$id/bus-details/$transportationId/trip-type/'
      path: '/'
      fullPath: '/make-booking/$id/bus-details/$transportationId/trip-type/'
      preLoaderRoute: typeof MakeBookingIdBusDetailsTransportationIdTripTypeIndexRouteImport
      parentRoute: typeof MakeBookingIdBusDetailsTransportationIdTripTypeRouteRoute
    }
    '/make-booking/$id/bus-details/$transportationId/time/': {
      id: '/make-booking/$id/bus-details/$transportationId/time/'
      path: '/'
      fullPath: '/make-booking/$id/bus-details/$transportationId/time/'
      preLoaderRoute: typeof MakeBookingIdBusDetailsTransportationIdTimeIndexRouteImport
      parentRoute: typeof MakeBookingIdBusDetailsTransportationIdTimeRouteRoute
    }
    '/make-booking/$id/bus-details/$transportationId/routes/': {
      id: '/make-booking/$id/bus-details/$transportationId/routes/'
      path: '/'
      fullPath: '/make-booking/$id/bus-details/$transportationId/routes/'
      preLoaderRoute: typeof MakeBookingIdBusDetailsTransportationIdRoutesIndexRouteImport
      parentRoute: typeof MakeBookingIdBusDetailsTransportationIdRoutesRouteRoute
    }
    '/make-booking/$id/bus-details/$transportationId/date/': {
      id: '/make-booking/$id/bus-details/$transportationId/date/'
      path: '/'
      fullPath: '/make-booking/$id/bus-details/$transportationId/date/'
      preLoaderRoute: typeof MakeBookingIdBusDetailsTransportationIdDateIndexRouteImport
      parentRoute: typeof MakeBookingIdBusDetailsTransportationIdDateRouteRoute
    }
    '/make-booking/$id/bus-details/$transportationId/add-ons/': {
      id: '/make-booking/$id/bus-details/$transportationId/add-ons/'
      path: '/'
      fullPath: '/make-booking/$id/bus-details/$transportationId/add-ons/'
      preLoaderRoute: typeof MakeBookingIdBusDetailsTransportationIdAddOnsIndexRouteImport
      parentRoute: typeof MakeBookingIdBusDetailsTransportationIdAddOnsRouteRoute
    }
    '/my-booking/$id/cancel/confirm/$transportationId/detail': {
      id: '/my-booking/$id/cancel/confirm/$transportationId/detail'
      path: '/$transportationId/detail'
      fullPath: '/my-booking/$id/cancel/confirm/$transportationId/detail'
      preLoaderRoute: typeof MyBookingIdCancelConfirmTransportationIdDetailRouteImport
      parentRoute: typeof MyBookingIdCancelConfirmRouteRoute
    }
    '/my-booking/$id/amend/view/$transportationId/detail': {
      id: '/my-booking/$id/amend/view/$transportationId/detail'
      path: '/detail'
      fullPath: '/my-booking/$id/amend/view/$transportationId/detail'
      preLoaderRoute: typeof MyBookingIdAmendViewTransportationIdDetailRouteImport
      parentRoute: typeof MyBookingIdAmendViewTransportationIdRouteRoute
    }
  }
}

interface HomeRouteRouteChildren {
  HomeIndexRoute: typeof HomeIndexRoute
}

const HomeRouteRouteChildren: HomeRouteRouteChildren = {
  HomeIndexRoute: HomeIndexRoute,
}

const HomeRouteRouteWithChildren = HomeRouteRoute._addFileChildren(
  HomeRouteRouteChildren,
)

interface ManageBookingIdRouteRouteChildren {
  ManageBookingIdIndexRoute: typeof ManageBookingIdIndexRoute
}

const ManageBookingIdRouteRouteChildren: ManageBookingIdRouteRouteChildren = {
  ManageBookingIdIndexRoute: ManageBookingIdIndexRoute,
}

const ManageBookingIdRouteRouteWithChildren =
  ManageBookingIdRouteRoute._addFileChildren(ManageBookingIdRouteRouteChildren)

interface ManageBookingRouteRouteChildren {
  ManageBookingIdRouteRoute: typeof ManageBookingIdRouteRouteWithChildren
  ManageBookingIndexRoute: typeof ManageBookingIndexRoute
}

const ManageBookingRouteRouteChildren: ManageBookingRouteRouteChildren = {
  ManageBookingIdRouteRoute: ManageBookingIdRouteRouteWithChildren,
  ManageBookingIndexRoute: ManageBookingIndexRoute,
}

const ManageBookingRouteRouteWithChildren =
  ManageBookingRouteRoute._addFileChildren(ManageBookingRouteRouteChildren)

interface MakeBookingIdCheckoutTransportationIdRouteRouteChildren {
  MakeBookingIdCheckoutTransportationIdDetailRoute: typeof MakeBookingIdCheckoutTransportationIdDetailRoute
}

const MakeBookingIdCheckoutTransportationIdRouteRouteChildren: MakeBookingIdCheckoutTransportationIdRouteRouteChildren =
  {
    MakeBookingIdCheckoutTransportationIdDetailRoute:
      MakeBookingIdCheckoutTransportationIdDetailRoute,
  }

const MakeBookingIdCheckoutTransportationIdRouteRouteWithChildren =
  MakeBookingIdCheckoutTransportationIdRouteRoute._addFileChildren(
    MakeBookingIdCheckoutTransportationIdRouteRouteChildren,
  )

interface MakeBookingIdCheckoutRouteRouteChildren {
  MakeBookingIdCheckoutTransportationIdRouteRoute: typeof MakeBookingIdCheckoutTransportationIdRouteRouteWithChildren
  MakeBookingIdCheckoutBillingRoute: typeof MakeBookingIdCheckoutBillingRoute
  MakeBookingIdCheckoutContactRoute: typeof MakeBookingIdCheckoutContactRoute
  MakeBookingIdCheckoutPocRoute: typeof MakeBookingIdCheckoutPocRoute
}

const MakeBookingIdCheckoutRouteRouteChildren: MakeBookingIdCheckoutRouteRouteChildren =
  {
    MakeBookingIdCheckoutTransportationIdRouteRoute:
      MakeBookingIdCheckoutTransportationIdRouteRouteWithChildren,
    MakeBookingIdCheckoutBillingRoute: MakeBookingIdCheckoutBillingRoute,
    MakeBookingIdCheckoutContactRoute: MakeBookingIdCheckoutContactRoute,
    MakeBookingIdCheckoutPocRoute: MakeBookingIdCheckoutPocRoute,
  }

const MakeBookingIdCheckoutRouteRouteWithChildren =
  MakeBookingIdCheckoutRouteRoute._addFileChildren(
    MakeBookingIdCheckoutRouteRouteChildren,
  )

interface MakeBookingIdPaymentRouteRouteChildren {
  MakeBookingIdPaymentCancelledRoute: typeof MakeBookingIdPaymentCancelledRoute
  MakeBookingIdPaymentConfirmedRoute: typeof MakeBookingIdPaymentConfirmedRoute
  MakeBookingIdPaymentFailedRoute: typeof MakeBookingIdPaymentFailedRoute
  MakeBookingIdPaymentInfoRoute: typeof MakeBookingIdPaymentInfoRoute
  MakeBookingIdPaymentProcessRoute: typeof MakeBookingIdPaymentProcessRoute
  MakeBookingIdPaymentSuccessRoute: typeof MakeBookingIdPaymentSuccessRoute
  MakeBookingIdPaymentIndexRoute: typeof MakeBookingIdPaymentIndexRoute
}

const MakeBookingIdPaymentRouteRouteChildren: MakeBookingIdPaymentRouteRouteChildren =
  {
    MakeBookingIdPaymentCancelledRoute: MakeBookingIdPaymentCancelledRoute,
    MakeBookingIdPaymentConfirmedRoute: MakeBookingIdPaymentConfirmedRoute,
    MakeBookingIdPaymentFailedRoute: MakeBookingIdPaymentFailedRoute,
    MakeBookingIdPaymentInfoRoute: MakeBookingIdPaymentInfoRoute,
    MakeBookingIdPaymentProcessRoute: MakeBookingIdPaymentProcessRoute,
    MakeBookingIdPaymentSuccessRoute: MakeBookingIdPaymentSuccessRoute,
    MakeBookingIdPaymentIndexRoute: MakeBookingIdPaymentIndexRoute,
  }

const MakeBookingIdPaymentRouteRouteWithChildren =
  MakeBookingIdPaymentRouteRoute._addFileChildren(
    MakeBookingIdPaymentRouteRouteChildren,
  )

interface MakeBookingIdTripDetailsTransportationIdRouteRouteChildren {
  MakeBookingIdTripDetailsTransportationIdDeleteRoute: typeof MakeBookingIdTripDetailsTransportationIdDeleteRoute
}

const MakeBookingIdTripDetailsTransportationIdRouteRouteChildren: MakeBookingIdTripDetailsTransportationIdRouteRouteChildren =
  {
    MakeBookingIdTripDetailsTransportationIdDeleteRoute:
      MakeBookingIdTripDetailsTransportationIdDeleteRoute,
  }

const MakeBookingIdTripDetailsTransportationIdRouteRouteWithChildren =
  MakeBookingIdTripDetailsTransportationIdRouteRoute._addFileChildren(
    MakeBookingIdTripDetailsTransportationIdRouteRouteChildren,
  )

interface MakeBookingIdTripDetailsRouteRouteChildren {
  MakeBookingIdTripDetailsTransportationIdRouteRoute: typeof MakeBookingIdTripDetailsTransportationIdRouteRouteWithChildren
  MakeBookingIdTripDetailsAddBusRoute: typeof MakeBookingIdTripDetailsAddBusRoute
  MakeBookingIdTripDetailsSigninRoute: typeof MakeBookingIdTripDetailsSigninRoute
}

const MakeBookingIdTripDetailsRouteRouteChildren: MakeBookingIdTripDetailsRouteRouteChildren =
  {
    MakeBookingIdTripDetailsTransportationIdRouteRoute:
      MakeBookingIdTripDetailsTransportationIdRouteRouteWithChildren,
    MakeBookingIdTripDetailsAddBusRoute: MakeBookingIdTripDetailsAddBusRoute,
    MakeBookingIdTripDetailsSigninRoute: MakeBookingIdTripDetailsSigninRoute,
  }

const MakeBookingIdTripDetailsRouteRouteWithChildren =
  MakeBookingIdTripDetailsRouteRoute._addFileChildren(
    MakeBookingIdTripDetailsRouteRouteChildren,
  )

interface MakeBookingIdBusDetailsTransportationIdAddOnsRouteRouteChildren {
  MakeBookingIdBusDetailsTransportationIdAddOnsIndexRoute: typeof MakeBookingIdBusDetailsTransportationIdAddOnsIndexRoute
}

const MakeBookingIdBusDetailsTransportationIdAddOnsRouteRouteChildren: MakeBookingIdBusDetailsTransportationIdAddOnsRouteRouteChildren =
  {
    MakeBookingIdBusDetailsTransportationIdAddOnsIndexRoute:
      MakeBookingIdBusDetailsTransportationIdAddOnsIndexRoute,
  }

const MakeBookingIdBusDetailsTransportationIdAddOnsRouteRouteWithChildren =
  MakeBookingIdBusDetailsTransportationIdAddOnsRouteRoute._addFileChildren(
    MakeBookingIdBusDetailsTransportationIdAddOnsRouteRouteChildren,
  )

interface MakeBookingIdBusDetailsTransportationIdDateRouteRouteChildren {
  MakeBookingIdBusDetailsTransportationIdDateIndexRoute: typeof MakeBookingIdBusDetailsTransportationIdDateIndexRoute
}

const MakeBookingIdBusDetailsTransportationIdDateRouteRouteChildren: MakeBookingIdBusDetailsTransportationIdDateRouteRouteChildren =
  {
    MakeBookingIdBusDetailsTransportationIdDateIndexRoute:
      MakeBookingIdBusDetailsTransportationIdDateIndexRoute,
  }

const MakeBookingIdBusDetailsTransportationIdDateRouteRouteWithChildren =
  MakeBookingIdBusDetailsTransportationIdDateRouteRoute._addFileChildren(
    MakeBookingIdBusDetailsTransportationIdDateRouteRouteChildren,
  )

interface MakeBookingIdBusDetailsTransportationIdRoutesRouteRouteChildren {
  MakeBookingIdBusDetailsTransportationIdRoutesIndexRoute: typeof MakeBookingIdBusDetailsTransportationIdRoutesIndexRoute
}

const MakeBookingIdBusDetailsTransportationIdRoutesRouteRouteChildren: MakeBookingIdBusDetailsTransportationIdRoutesRouteRouteChildren =
  {
    MakeBookingIdBusDetailsTransportationIdRoutesIndexRoute:
      MakeBookingIdBusDetailsTransportationIdRoutesIndexRoute,
  }

const MakeBookingIdBusDetailsTransportationIdRoutesRouteRouteWithChildren =
  MakeBookingIdBusDetailsTransportationIdRoutesRouteRoute._addFileChildren(
    MakeBookingIdBusDetailsTransportationIdRoutesRouteRouteChildren,
  )

interface MakeBookingIdBusDetailsTransportationIdTimeRouteRouteChildren {
  MakeBookingIdBusDetailsTransportationIdTimeIndexRoute: typeof MakeBookingIdBusDetailsTransportationIdTimeIndexRoute
}

const MakeBookingIdBusDetailsTransportationIdTimeRouteRouteChildren: MakeBookingIdBusDetailsTransportationIdTimeRouteRouteChildren =
  {
    MakeBookingIdBusDetailsTransportationIdTimeIndexRoute:
      MakeBookingIdBusDetailsTransportationIdTimeIndexRoute,
  }

const MakeBookingIdBusDetailsTransportationIdTimeRouteRouteWithChildren =
  MakeBookingIdBusDetailsTransportationIdTimeRouteRoute._addFileChildren(
    MakeBookingIdBusDetailsTransportationIdTimeRouteRouteChildren,
  )

interface MakeBookingIdBusDetailsTransportationIdTripTypeRouteRouteChildren {
  MakeBookingIdBusDetailsTransportationIdTripTypeIndexRoute: typeof MakeBookingIdBusDetailsTransportationIdTripTypeIndexRoute
}

const MakeBookingIdBusDetailsTransportationIdTripTypeRouteRouteChildren: MakeBookingIdBusDetailsTransportationIdTripTypeRouteRouteChildren =
  {
    MakeBookingIdBusDetailsTransportationIdTripTypeIndexRoute:
      MakeBookingIdBusDetailsTransportationIdTripTypeIndexRoute,
  }

const MakeBookingIdBusDetailsTransportationIdTripTypeRouteRouteWithChildren =
  MakeBookingIdBusDetailsTransportationIdTripTypeRouteRoute._addFileChildren(
    MakeBookingIdBusDetailsTransportationIdTripTypeRouteRouteChildren,
  )

interface MakeBookingIdBusDetailsTransportationIdRouteRouteChildren {
  MakeBookingIdBusDetailsTransportationIdAddOnsRouteRoute: typeof MakeBookingIdBusDetailsTransportationIdAddOnsRouteRouteWithChildren
  MakeBookingIdBusDetailsTransportationIdDateRouteRoute: typeof MakeBookingIdBusDetailsTransportationIdDateRouteRouteWithChildren
  MakeBookingIdBusDetailsTransportationIdRoutesRouteRoute: typeof MakeBookingIdBusDetailsTransportationIdRoutesRouteRouteWithChildren
  MakeBookingIdBusDetailsTransportationIdTimeRouteRoute: typeof MakeBookingIdBusDetailsTransportationIdTimeRouteRouteWithChildren
  MakeBookingIdBusDetailsTransportationIdTripTypeRouteRoute: typeof MakeBookingIdBusDetailsTransportationIdTripTypeRouteRouteWithChildren
  MakeBookingIdBusDetailsTransportationIdChangeBusRoute: typeof MakeBookingIdBusDetailsTransportationIdChangeBusRoute
}

const MakeBookingIdBusDetailsTransportationIdRouteRouteChildren: MakeBookingIdBusDetailsTransportationIdRouteRouteChildren =
  {
    MakeBookingIdBusDetailsTransportationIdAddOnsRouteRoute:
      MakeBookingIdBusDetailsTransportationIdAddOnsRouteRouteWithChildren,
    MakeBookingIdBusDetailsTransportationIdDateRouteRoute:
      MakeBookingIdBusDetailsTransportationIdDateRouteRouteWithChildren,
    MakeBookingIdBusDetailsTransportationIdRoutesRouteRoute:
      MakeBookingIdBusDetailsTransportationIdRoutesRouteRouteWithChildren,
    MakeBookingIdBusDetailsTransportationIdTimeRouteRoute:
      MakeBookingIdBusDetailsTransportationIdTimeRouteRouteWithChildren,
    MakeBookingIdBusDetailsTransportationIdTripTypeRouteRoute:
      MakeBookingIdBusDetailsTransportationIdTripTypeRouteRouteWithChildren,
    MakeBookingIdBusDetailsTransportationIdChangeBusRoute:
      MakeBookingIdBusDetailsTransportationIdChangeBusRoute,
  }

const MakeBookingIdBusDetailsTransportationIdRouteRouteWithChildren =
  MakeBookingIdBusDetailsTransportationIdRouteRoute._addFileChildren(
    MakeBookingIdBusDetailsTransportationIdRouteRouteChildren,
  )

interface MakeBookingIdRouteRouteChildren {
  MakeBookingIdCheckoutRouteRoute: typeof MakeBookingIdCheckoutRouteRouteWithChildren
  MakeBookingIdPaymentRouteRoute: typeof MakeBookingIdPaymentRouteRouteWithChildren
  MakeBookingIdTripDetailsRouteRoute: typeof MakeBookingIdTripDetailsRouteRouteWithChildren
  MakeBookingIdIndexRoute: typeof MakeBookingIdIndexRoute
  MakeBookingIdBusDetailsTransportationIdRouteRoute: typeof MakeBookingIdBusDetailsTransportationIdRouteRouteWithChildren
}

const MakeBookingIdRouteRouteChildren: MakeBookingIdRouteRouteChildren = {
  MakeBookingIdCheckoutRouteRoute: MakeBookingIdCheckoutRouteRouteWithChildren,
  MakeBookingIdPaymentRouteRoute: MakeBookingIdPaymentRouteRouteWithChildren,
  MakeBookingIdTripDetailsRouteRoute:
    MakeBookingIdTripDetailsRouteRouteWithChildren,
  MakeBookingIdIndexRoute: MakeBookingIdIndexRoute,
  MakeBookingIdBusDetailsTransportationIdRouteRoute:
    MakeBookingIdBusDetailsTransportationIdRouteRouteWithChildren,
}

const MakeBookingIdRouteRouteWithChildren =
  MakeBookingIdRouteRoute._addFileChildren(MakeBookingIdRouteRouteChildren)

interface MyBookingIdAmendViewTransportationIdRouteRouteChildren {
  MyBookingIdAmendViewTransportationIdDetailRoute: typeof MyBookingIdAmendViewTransportationIdDetailRoute
}

const MyBookingIdAmendViewTransportationIdRouteRouteChildren: MyBookingIdAmendViewTransportationIdRouteRouteChildren =
  {
    MyBookingIdAmendViewTransportationIdDetailRoute:
      MyBookingIdAmendViewTransportationIdDetailRoute,
  }

const MyBookingIdAmendViewTransportationIdRouteRouteWithChildren =
  MyBookingIdAmendViewTransportationIdRouteRoute._addFileChildren(
    MyBookingIdAmendViewTransportationIdRouteRouteChildren,
  )

interface MyBookingIdAmendViewRouteRouteChildren {
  MyBookingIdAmendViewTransportationIdRouteRoute: typeof MyBookingIdAmendViewTransportationIdRouteRouteWithChildren
}

const MyBookingIdAmendViewRouteRouteChildren: MyBookingIdAmendViewRouteRouteChildren =
  {
    MyBookingIdAmendViewTransportationIdRouteRoute:
      MyBookingIdAmendViewTransportationIdRouteRouteWithChildren,
  }

const MyBookingIdAmendViewRouteRouteWithChildren =
  MyBookingIdAmendViewRouteRoute._addFileChildren(
    MyBookingIdAmendViewRouteRouteChildren,
  )

interface MyBookingIdAmendRouteRouteChildren {
  MyBookingIdAmendViewRouteRoute: typeof MyBookingIdAmendViewRouteRouteWithChildren
  MyBookingIdAmendConfirmRoute: typeof MyBookingIdAmendConfirmRoute
}

const MyBookingIdAmendRouteRouteChildren: MyBookingIdAmendRouteRouteChildren = {
  MyBookingIdAmendViewRouteRoute: MyBookingIdAmendViewRouteRouteWithChildren,
  MyBookingIdAmendConfirmRoute: MyBookingIdAmendConfirmRoute,
}

const MyBookingIdAmendRouteRouteWithChildren =
  MyBookingIdAmendRouteRoute._addFileChildren(
    MyBookingIdAmendRouteRouteChildren,
  )

interface MyBookingIdCancelConfirmRouteRouteChildren {
  MyBookingIdCancelConfirmTransportationIdDetailRoute: typeof MyBookingIdCancelConfirmTransportationIdDetailRoute
}

const MyBookingIdCancelConfirmRouteRouteChildren: MyBookingIdCancelConfirmRouteRouteChildren =
  {
    MyBookingIdCancelConfirmTransportationIdDetailRoute:
      MyBookingIdCancelConfirmTransportationIdDetailRoute,
  }

const MyBookingIdCancelConfirmRouteRouteWithChildren =
  MyBookingIdCancelConfirmRouteRoute._addFileChildren(
    MyBookingIdCancelConfirmRouteRouteChildren,
  )

interface MyBookingIdCancelRouteRouteChildren {
  MyBookingIdCancelConfirmRouteRoute: typeof MyBookingIdCancelConfirmRouteRouteWithChildren
  MyBookingIdCancelIndexRoute: typeof MyBookingIdCancelIndexRoute
}

const MyBookingIdCancelRouteRouteChildren: MyBookingIdCancelRouteRouteChildren =
  {
    MyBookingIdCancelConfirmRouteRoute:
      MyBookingIdCancelConfirmRouteRouteWithChildren,
    MyBookingIdCancelIndexRoute: MyBookingIdCancelIndexRoute,
  }

const MyBookingIdCancelRouteRouteWithChildren =
  MyBookingIdCancelRouteRoute._addFileChildren(
    MyBookingIdCancelRouteRouteChildren,
  )

interface MyBookingIdViewTransportationIdRouteRouteChildren {
  MyBookingIdViewTransportationIdAmendRoute: typeof MyBookingIdViewTransportationIdAmendRoute
  MyBookingIdViewTransportationIdDetailRoute: typeof MyBookingIdViewTransportationIdDetailRoute
}

const MyBookingIdViewTransportationIdRouteRouteChildren: MyBookingIdViewTransportationIdRouteRouteChildren =
  {
    MyBookingIdViewTransportationIdAmendRoute:
      MyBookingIdViewTransportationIdAmendRoute,
    MyBookingIdViewTransportationIdDetailRoute:
      MyBookingIdViewTransportationIdDetailRoute,
  }

const MyBookingIdViewTransportationIdRouteRouteWithChildren =
  MyBookingIdViewTransportationIdRouteRoute._addFileChildren(
    MyBookingIdViewTransportationIdRouteRouteChildren,
  )

interface MyBookingIdViewRouteRouteChildren {
  MyBookingIdViewTransportationIdRouteRoute: typeof MyBookingIdViewTransportationIdRouteRouteWithChildren
  MyBookingIdViewCancelRoute: typeof MyBookingIdViewCancelRoute
  MyBookingIdViewPaymentDetailRoute: typeof MyBookingIdViewPaymentDetailRoute
  MyBookingIdViewPocRoute: typeof MyBookingIdViewPocRoute
}

const MyBookingIdViewRouteRouteChildren: MyBookingIdViewRouteRouteChildren = {
  MyBookingIdViewTransportationIdRouteRoute:
    MyBookingIdViewTransportationIdRouteRouteWithChildren,
  MyBookingIdViewCancelRoute: MyBookingIdViewCancelRoute,
  MyBookingIdViewPaymentDetailRoute: MyBookingIdViewPaymentDetailRoute,
  MyBookingIdViewPocRoute: MyBookingIdViewPocRoute,
}

const MyBookingIdViewRouteRouteWithChildren =
  MyBookingIdViewRouteRoute._addFileChildren(MyBookingIdViewRouteRouteChildren)

interface MyBookingIdRouteRouteChildren {
  MyBookingIdAmendRouteRoute: typeof MyBookingIdAmendRouteRouteWithChildren
  MyBookingIdCancelRouteRoute: typeof MyBookingIdCancelRouteRouteWithChildren
  MyBookingIdViewRouteRoute: typeof MyBookingIdViewRouteRouteWithChildren
  MyBookingIdPaymentRoute: typeof MyBookingIdPaymentRoute
  MyBookingIdIndexRoute: typeof MyBookingIdIndexRoute
}

const MyBookingIdRouteRouteChildren: MyBookingIdRouteRouteChildren = {
  MyBookingIdAmendRouteRoute: MyBookingIdAmendRouteRouteWithChildren,
  MyBookingIdCancelRouteRoute: MyBookingIdCancelRouteRouteWithChildren,
  MyBookingIdViewRouteRoute: MyBookingIdViewRouteRouteWithChildren,
  MyBookingIdPaymentRoute: MyBookingIdPaymentRoute,
  MyBookingIdIndexRoute: MyBookingIdIndexRoute,
}

const MyBookingIdRouteRouteWithChildren =
  MyBookingIdRouteRoute._addFileChildren(MyBookingIdRouteRouteChildren)

interface MyBookingListIdRouteRouteChildren {
  MyBookingListIdDeleteRoute: typeof MyBookingListIdDeleteRoute
}

const MyBookingListIdRouteRouteChildren: MyBookingListIdRouteRouteChildren = {
  MyBookingListIdDeleteRoute: MyBookingListIdDeleteRoute,
}

const MyBookingListIdRouteRouteWithChildren =
  MyBookingListIdRouteRoute._addFileChildren(MyBookingListIdRouteRouteChildren)

interface MyBookingListRouteRouteChildren {
  MyBookingListIdRouteRoute: typeof MyBookingListIdRouteRouteWithChildren
}

const MyBookingListRouteRouteChildren: MyBookingListRouteRouteChildren = {
  MyBookingListIdRouteRoute: MyBookingListIdRouteRouteWithChildren,
}

const MyBookingListRouteRouteWithChildren =
  MyBookingListRouteRoute._addFileChildren(MyBookingListRouteRouteChildren)

interface MyBookingRefundIdTransportationIdRouteRouteChildren {
  MyBookingRefundIdTransportationIdDetailRoute: typeof MyBookingRefundIdTransportationIdDetailRoute
}

const MyBookingRefundIdTransportationIdRouteRouteChildren: MyBookingRefundIdTransportationIdRouteRouteChildren =
  {
    MyBookingRefundIdTransportationIdDetailRoute:
      MyBookingRefundIdTransportationIdDetailRoute,
  }

const MyBookingRefundIdTransportationIdRouteRouteWithChildren =
  MyBookingRefundIdTransportationIdRouteRoute._addFileChildren(
    MyBookingRefundIdTransportationIdRouteRouteChildren,
  )

interface MyBookingRefundIdRouteRouteChildren {
  MyBookingRefundIdTransportationIdRouteRoute: typeof MyBookingRefundIdTransportationIdRouteRouteWithChildren
}

const MyBookingRefundIdRouteRouteChildren: MyBookingRefundIdRouteRouteChildren =
  {
    MyBookingRefundIdTransportationIdRouteRoute:
      MyBookingRefundIdTransportationIdRouteRouteWithChildren,
  }

const MyBookingRefundIdRouteRouteWithChildren =
  MyBookingRefundIdRouteRoute._addFileChildren(
    MyBookingRefundIdRouteRouteChildren,
  )

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  HomeRouteRoute: HomeRouteRouteWithChildren,
  ManageBookingRouteRoute: ManageBookingRouteRouteWithChildren,
  AccountRoute: AccountRoute,
  AccountChangePasswordRoute: AccountChangePasswordRoute,
  AccountVerifyEmailRoute: AccountVerifyEmailRoute,
  DeleteAccountSuccessRoute: DeleteAccountSuccessRoute,
  HelpSupportRoute: HelpSupportRoute,
  InboxRoute: InboxRoute,
  SuccessChangePassAccountRoute: SuccessChangePassAccountRoute,
  MakeBookingIdRouteRoute: MakeBookingIdRouteRouteWithChildren,
  MyBookingIdRouteRoute: MyBookingIdRouteRouteWithChildren,
  MyBookingListRouteRoute: MyBookingListRouteRouteWithChildren,
  AuthChangePasswordRoute: AuthChangePasswordRoute,
  AuthCheckYourInboxRoute: AuthCheckYourInboxRoute,
  AuthLoginRoute: AuthLoginRoute,
  AuthLogoutRoute: AuthLogoutRoute,
  AuthRegisterRoute: AuthRegisterRoute,
  AuthResetPasswordRoute: AuthResetPasswordRoute,
  AuthSuccessChangePassRoute: AuthSuccessChangePassRoute,
  AuthSuccessRegisterRoute: AuthSuccessRegisterRoute,
  AuthVerifyEmailRoute: AuthVerifyEmailRoute,
  DemoTanstackQueryRoute: DemoTanstackQueryRoute,
  MyBookingRefundIdRouteRoute: MyBookingRefundIdRouteRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
